/**
 * Google Recaptcha callback
 */
var LEOCaptchaReady = false;
var LEOCaptchaQueue = [];
var LEOCaptchaWidgetId = "";
var LEOCaptchaCompleter = [];
window.setLEOCaptchaReady = function() {
    var LEOCaptcha = document.getElementById("LEOCaptcha");
    if(LEOCaptcha) {
        LEOCaptchaWidgetId = grecaptcha.render(LEOCaptcha, {}, true);
        LEOCaptchaReady = true;
        while(LEOCaptchaQueue.length) {
            LEOCaptchaQueue.shift()();
        }
    }
};
window.LEOCaughtya = function(response) {
    LEOCaptchaCompleter.shift()(response);
};


(function($) {
    $(function() {

        /**
         *  general helper
         */

        var currentlyShownLayerStack = [];

        function care() {
            var $currentlyShownLayer = currentlyShownLayerStack[0];                        // only care for the first openend layer, layer above layers like promotion layer are "tooltips"
            if($currentlyShownLayer[0].scrollHeight > $currentlyShownLayer.height()) {
                if(document.documentElement.scrollHeight > innerHeight) {
                    if(!document.documentElement.classList.contains("hidden-scrollbar")) {
                        var $header = $("header");
                        var headerWidth = $header.width();
                        var scrollbarWidth = innerWidth - headerWidth;
                        document.body.style.marginRight = scrollbarWidth + "px";
                        $header.width(headerWidth).addClass("fakeLine1Continuation");
                        $(".servicenavi").css({"right": scrollbarWidth + "px"});
                        $currentlyShownLayer.css({"paddingLeft": scrollbarWidth + "px"});
                        document.documentElement.classList.add("hidden-scrollbar");
                    }
                }
            } else {
                document.documentElement.classList.remove("hidden-scrollbar");
                document.body.style.marginRight = "";
                $("header").width("").removeClass("fakeLine1Continuation");
                $(".servicenavi").css({"right": ""});
                $currentlyShownLayer.css({"paddingLeft": ""});
            }
        }

        function careForLayerScrollbarVisible($x) {
            var $currentlyShownLayer = $x.closest(".layer");
            if($currentlyShownLayer.length) {
                if(currentlyShownLayerStack.length === 0 || $currentlyShownLayer[0] !== currentlyShownLayerStack[currentlyShownLayerStack.length - 1][0]) {
                    currentlyShownLayerStack.push($currentlyShownLayer);
                    if(currentlyShownLayerStack.length === 1) {
                        addEventListener("resize", care);
                    }
                }
                care();
            }
        }

        function careForBodyScrollbarRestored($x) {
            if($x.hasClass("layer")) {
                var $currentlyShownLayer = currentlyShownLayerStack.pop();
                document.documentElement.classList.remove("hidden-scrollbar");
                document.body.style.marginRight = "";
                $("header").width("").removeClass("fakeLine1Continuation");
                $(".servicenavi").css({"right": ""});
                $currentlyShownLayer?.css({"paddingLeft": ""});
                if(currentlyShownLayerStack.length === 0) {
                    removeEventListener("resize", care);
                } else {
                    care();
                }
            }
        }

        window.hide = function ($x) {
            $x.removeClass("shown");
            careForBodyScrollbarRestored($x);
        };

        window.show = function($x) {
            hide($x.addClass("shown").find(".shown"));                              // reset all shown sub layer
            careForLayerScrollbarVisible($x);
        };

        window.showIgnoreSubs = function($x) {
            $x.addClass("shown");
        };

        window.toggle = function ($x) {
            $x.toggleClass("shown"); 
        };

        function enableInput($x) {
            $x.removeAttr("disabled").parent().removeClass("disabled");
        }

        function disableInput($x) {
            $x.attr("disabled", "").parent().addClass("disabled");
        }

        function markInputSuccess($x) {
            $x.parent().addClass("success");
        }

        function demarkInputSuccess($x) {
            $x.parent().removeClass("success");
        }

        window.showListItem = function($x) {
            $x.addClass("shownListItem");
        };


        /**
         *  breadcrumb
         */
        (function placeBreadcrumb() {
            var $x = $("footer");
            if($x.length) {
                $("#breadcrumb").insertBefore($x);
            }
            setTimeout(function() {
                show($("#breadcrumb"));
            }, 0);
        })();


        /**
         *  scroll-dependant functionality
         */
        var totop = document.querySelector("footer .servicenavi .totop");
        if(totop) {
            function totopVisibility() {
                document.documentElement.scrollTop > 0 ? totop.classList.add("visible") : totop.classList.remove("visible");
            }
            totopVisibility();
            addEventListener("scroll", totopVisibility);
        }


        /**
         *  make cookies accessible
         */
        window.LEOCookies = {};
        window.readLEOCookies = function() {
            LEOCookies = {};
            document.cookie.split(";").forEach(function(c) {
                var kv = c.split("=");
                LEOCookies[kv[0].trim()] = kv.length > 1 ? kv[1].trim() : "";
            });
        };
        readLEOCookies();


        /* cross-tab session synchronisation on initial new tab */
        var tabId;                              // each tab has an id
        var isChannelCaptain = false;           // the channel captain distributes its sessionStorage to new tabs (if availability was already checked)
        var channelMembers;                     // list of ids of all joined tabs
        var unbusyLEOSessionStorage = true;     // if a sessionStorage change would incur a broadcast this flag disables this (useful when initially filling the sessionStorage)
        var leonetSessionSynchronisationChannel = new BroadcastChannel("toniSessionSynchronisationChannel");      // message format: ["message", data...]
        function storeChannelMembers() {
            document.cookie = "channelMembers=" + JSON.stringify(channelMembers) + ";path=/";
        }
        function removeTabFromChannel() {
            var removeIndex = channelMembers.list.indexOf(tabId);
            if(removeIndex > -1) {
                channelMembers.list.splice(removeIndex, 1);
                storeChannelMembers();
            }
        }
        function updateChannelMembers() {
            readLEOCookies();
            if(LEOCookies.hasOwnProperty("channelMembers")) {
                try {
                    channelMembers = JSON.parse(LEOCookies["channelMembers"]);
                    return Array.isArray(channelMembers.list);
                } catch(e) {}
            }
            return false;
        }
        leonetSessionSynchronisationChannel.onmessage = (event) => {
            switch(event.data[0]) {
                case "joined":
                    if(isChannelCaptain && sessionStorage.getItem("availabilitychecked") === "true") {
                        var session = {};
                        Object.keys(sessionStorage).forEach(key => {
                            session[key] = sessionStorage.getItem(key);
                        });
                        leonetSessionSynchronisationChannel.postMessage(["sessionData", event.data[1], JSON.stringify(session)]);
                    }
                    break;
                case "captainLeft":
                    if(updateChannelMembers() && channelMembers.list.length) {
                        isChannelCaptain = channelMembers.list[0] === tabId;
                    }
                    break;
                case "sessionData":
                    if(event.data[1] === tabId && sessionStorage.getItem("availabilitychecked") !== "true") {
                        var newSessionStorage = JSON.parse(event.data[2]);
                        unbusyLEOSessionStorage = false;
                        for(var key in newSessionStorage) {
                            sessionStorage.setItem(key, newSessionStorage[key]);
                        }
                        location.reload();          // apply sessionStorage (code using it already run initially using an empty storage, thus reload)
                    }
                    break;
                case "captainReclaimed":
                    isChannelCaptain = false;
                    break;
                default:
            }
        };
        addEventListener("beforeunload", () => {
            if(updateChannelMembers()) {
                removeTabFromChannel();
                unbusyLEOSessionStorage = false;
                sessionStorage.setItem(isChannelCaptain ? "captainIdToRetake" : "tabIdToRetake", tabId);
                unbusyLEOSessionStorage = true;
                isChannelCaptain ? leonetSessionSynchronisationChannel.postMessage(["captainLeft"]) : 0;
            }
        });
        var messageToPost;
        if(updateChannelMembers()) {
            if(typeof channelMembers.everAmount === "number") {
                var captainIdToRetake = sessionStorage.getItem("captainIdToRetake");
                if(captainIdToRetake) {
                    tabId = +captainIdToRetake;
                    isChannelCaptain = true;
                    unbusyLEOSessionStorage = false;
                    sessionStorage.removeItem("captainIdToRetake");
                    unbusyLEOSessionStorage = true;
                    channelMembers.list.unshift(tabId);
                    messageToPost = ["captainReclaimed"];
                } else if(!channelMembers.list.length) {
                    tabId = 0;
                    isChannelCaptain = true;
                    channelMembers = {
                        "list": [0],
                        "everAmount": 1
                    };
                } else {
                    var tabIdToRetake = sessionStorage.getItem("tabIdToRetake");
                    if(tabIdToRetake) {
                        tabId = +tabIdToRetake;
                        unbusyLEOSessionStorage = false;
                        sessionStorage.removeItem("tabIdToRetake");
                        unbusyLEOSessionStorage = true;
                    } else {
                        tabId = channelMembers.everAmount++;
                        if(!sessionStorage.getItem("nojoin")) {
                            messageToPost = ["joined", tabId];
                        } else {
                            sessionStorage.removeItem("nojoin");
                        }
                    }
                    channelMembers.list.push(tabId);
                }
            }
        } else {
            tabId = 0;
            isChannelCaptain = true;
            channelMembers = {
                "list": [0],
                "everAmount": 1
            };
        }
        storeChannelMembers();
        if(messageToPost) {
            leonetSessionSynchronisationChannel.postMessage(messageToPost);
        }


        /**
         *  clean and clear data such as cookie data on defined conditions
         */
        var state = {};
        function saveState() {
            if(LEOCookies["promo-doa"] === "1" && sessionStorage.getItem("street") !== null) {
                state["hasDOAPromoAndStreet"] = true;
            } else {
                state["hasDOAPromoAndStreet"] = false;
            }
            if(location.pathname.startsWith("/bestellstrecke")) {
                // LEOSERVICE-581
                state["inOrderProcess"] = true;
                state["cookie-promo"] = LEOCookies["promo"];
                state["cookie-promo-doa"] = LEOCookies["promo-doa"];
            } else {
                state["inOrderProcess"] = false;
            }
        }
        addEventListener("blur", saveState);
        function keepDataUpToDate() {
            readLEOCookies();
            // LEOSERVICE-581 UPDATE
            return;         // no actions for now            
            // LEOSERVICE-581 UPDATE END
            if(LEOCookies["promo-doa"] === "1" && sessionStorage.getItem("street") === null) {
                // LEOSERVICE-474
                document.cookie = "promo=;path=/;Max-Age=0";
                document.cookie = "promo-doa=;path=/;Max-Age=0";
                location.reload();
                return;
            }
            if(LEOCookies["promo-doa"] !== "1" && state["hasDOAPromoAndStreet"]) {
                if(!state["inOrderProcess"]) {
                    sessionStorage.clear();
                    location.reload();
                } else {
                    // LEOSERVICE-581
                    document.cookie = "promo=" + state["cookie-promo"] + ";path=/";
                    document.cookie = "promo-doa=" + state["cookie-promo-doa"] + ";path=/";
                    readLEOCookies();
                }
                return;
            }
        }
        addEventListener("focus", function() {
            keepDataUpToDate();
        });


        /**
         * invalidate availability data, without deleting landing page promo cookies
         */
        window.clearSession = function (silent) {
            sessionStorage.clear();
            document.cookie = "availabilitychecked=;path=/;Max-Age=0";
            if(silent !== true) {
                alert("Ihre Verfügbarkeitsabfragedaten sind nicht mehr gültig.\n\nWir leiten Sie nun auf die Homepage.");
                location.href = "/";
            } else {                
                keepDataUpToDate();
                $("body").removeAttr("downstream-is").removeClass("availability-check-performed availability-not-given availability-given availability-restricted rate-feedback-active from-single-landing").addClass("availability-check-not-performed");
                $("#detailAvailableBubble").css({"display": "none"});
                $(".rate[data-articleid]").removeClass("js-rate-availability-given rate-availability-not-given js-presentable");
                $(".user-checked-data").html("");
                hide($(".tarif-rckmeldungen"));
                $("#verfuegbarkeit").removeClass("landing-available landing-not-available");
                $("[recommended]").removeAttr("recommended");
                $("[data-longtext]").off("mouseenter touchstart mouseleave");
            }
        };
        if(document.body.classList.contains("single-landing")) {
            if(!sessionStorage.getItem("sessionCleared")) {
                clearSession(true);
                sessionStorage.setItem("sessionCleared", "1");
            } else {
                performance.getEntriesByType("navigation").forEach(entry => {
                    if (entry.type === "back_forward") {
                        //alert("Ihre bisherigen Aktionsdaten, sofern vorhanden, werden gelöscht.\n\nBitte führen Sie ggf. eine neue Verfügbarkeitsprüfung durch.");
                        clearSession(true);
                        sessionStorage.setItem("sessionCleared", "1");
                    }
                });
            }
        }


        /**
         * header positioning
         */
        var header = document.querySelector("header");
        if(header) {
            var oldScrollTop = document.documentElement.scrollTop;
            var scrollWasAt0 = oldScrollTop < header.clientHeight;
            function positionHeader() {
                var hCH = header.clientHeight;
                var newScrollTop = document.documentElement.scrollTop;
                if(newScrollTop > oldScrollTop) {
                    // scroll down (finger moves up)
                    if(newScrollTop > hCH) {
                        // outside of header height (transition out at viewport top (= fixed) ie add hidden (and remove not-fixed))
                        if(oldScrollTop <= hCH && scrollWasAt0) {
                            // transitioning from inside header height to outside thus a visible header must be hidden but without showing the transition ie needs to be instant
                            // only if we have reached the top (scrollTop = 0) before because if not we were scrolling up before which resulted in a transition in which we now want to just undo
                            scrollWasAt0 = false;
                            header.classList.add("instant");
                        } else {
                            header.classList.remove("instant");
                        }
                        header.classList.remove("not-fixed");
                        header.classList.add("hidden");
                    } else {
                        // inside of header height (ie visible (remove hidden), no instant (instant only for special case above), and scroll with content (= not fixed) by default (= when having been at top (scrollTop = 0)))
                        header.classList.remove("instant");
                        if(scrollWasAt0) {
                            // "case A"
                            header.classList.add("not-fixed");
                        } else {
                            // but if not having been at top we had scrolled up before which resulted in a transition in at viewport top and we keep it there visible, we don't hide it on scroll down here because then a white background would be visible (we have scrolled less than the header height)
                            header.classList.remove("not-fixed");
                        }
                        header.classList.remove("hidden");
                    }
                } else {
                    // scroll up (finger moves down) (ie visible, no instant (same reason like before), fixed)
                    if(newScrollTop > hCH) {
                        // ususally on page is outside of header
                        header.classList.remove("instant");
                        header.classList.remove("not-fixed");
                        header.classList.remove("hidden");
                    } else {
                        // now within header height
                        if(oldScrollTop > hCH) {
                            // "case B"
                            header.classList.remove("instant");
                            header.classList.remove("not-fixed");
                            header.classList.remove("hidden");
                        } else {
                            // leave state as it is: whatever it is (we started at top and stayed within header height (case A) or we came from outside header height before and continue to top (case B))
                        }
                        if(newScrollTop <= 0) {
                            // we reached the top (scrollTop = 0)
                            scrollWasAt0 = true;
                            header.classList.add("not-fixed");
                        }
                    }
                }
                oldScrollTop = newScrollTop;
            }
            addEventListener("scroll", positionHeader);
        }


        /**
         *  menu
         */
        function openMobMenu() {
            $(this).toggleClass('close').next().toggleClass('menu'); 
        }
        $(".mobile-menu-toggle").on("click", openMobMenu);
        

        function openSubMenu() {
            $(this).toggleClass('close2').next().toggleClass('menu2');
        }
        $(".main-page-menu-title").on("click", openSubMenu);


        /**
         * to top
         */
        function positionTopOfPageAtTopOfViewport(e) {
            e.preventDefault();
            scrollTo(0, 0);
        }
        $("footer .servicenavi .totop").on("click", positionTopOfPageAtTopOfViewport);


        /**
         * cookie options link
         */
        $('[href="#cookieoptions"]').addClass("borlabs-cookie-preference");


        /**
         *  faq
         */
        window.openFaq = function () {            
            $(this).next('.schema-faq-answer').toggle(); 
            $(this).toggleClass('anim').next('.schema-faq-answer').toggleClass('p-anim');
        };
        $(".schema-faq-question").on("click", openFaq);
        
        $(".faq-open-default .schema-faq-answer").each(function() {
            $(this).show();
        });
		

        /**
         *  download
         */
        window.openDownload = function () {        
            $(this).nextAll('.download-container').toggleClass('block-file');  
            $(this).toggleClass('anim');
        };
        $(".downloadkategorie").on("click", openDownload);


        /**
         *  predefine availability check flag
         */

        var availabilityResultIsValid = false;

        
        /**
         *  layer
         */
        if(location.hash.length > 1) {
            var notInitialHashPage = false;
            history.replaceState({initial:true}, "", location.href);
            onpopstate = (e) => {
                if(e.state?.initial) {
                    notInitialHashPage = false;
                } else {
                    notInitialHashPage = true;
                }
            };
        } else {
            var notInitialHashPage = true;
        }
        function removeHash() {
            history.replaceState({}, "", location.href.split("#")[0]);
        }
        function closeLayer(e) {
            e.preventDefault();
            var $shown = $(".layer .shown");
            if($shown.length) {
                hide($shown);
            } else {
                hide($(".layer.shown"));
            }
            if(notInitialHashPage) {
                history.back();
            } else {
                hide($(".layer.shown"));
                removeHash();
            }
        }
        $(".layer").on("click", '[href="#schliessen"], [href="#aendern"]', closeLayer);

        function closeAllLayer() {
            hide($(".layer.shown, .layer .shown"));
        }
        function closeAllLayerAndClearHash(e, state = {}) {
            closeAllLayer();
            var closeLink = this;
            setTimeout(function() {                                                             // let hash change due to possible #-href on clicked link apply
                history.replaceState(state, "", location.href.split("#")[0]);
                if(($(".rate").length || $("body.rates-template").length) && $(closeLink).closest("#verfuegbarkeit").length) {       // reload page when conditions met because BE might deliver different rate bubble text when promotion changes
                    location.reload();
                }
            }, 0);
        }
        $("#Ergebnis").on("click", ".js-close-all", closeAllLayerAndClearHash);


        var lastLayerName;
        var lastResultLayerName;
        var $lastTarget;
        var $lastResultTarget;
        var lastLayerContent;
        var lastResultLayerHasLayerContent;
        var indirectResult = true;
        const $resultLayer = $("#Ergebnis");
        const $runtimeLayerContainer = $('<div><div class="result-container gfha-like" id="ErgebnisRuntime"><a href="#schliessePruefungKomplett" class="close js-close-all"></a><div class="resulttext downstream downstream-30"></div></div></div>');
            
        function replacePlaceholderByData($target) {
            $target.find(".resulttext").each(function() {
                this.innerHTML = this.innerHTML.replace(/ADRESSEHIER/g, "<span class='addressplacement'></span>").replace(/\$PROJECT_END/g, "<span class='projectenddate'></span>");
                var $this = $(this);
                $this.find(".addressplacement").html(sessionStorage.getItem("street") + " " + sessionStorage.getItem("housenumber") + ", " + sessionStorage.getItem("plzort"));
                $this.find(".projectenddate").html(sessionStorage.getItem("projectend"));
                $this.find("[data-longtext]").off("mouseenter touchstart mouseleave").on("mouseenter touchstart", showPromotionLayer).on("mouseleave", function() {
                    hide($("#Promotion"));
                });
                $this.find("[data-campaigns]").hide();
                var counter = 0;
                var campaigns = sessionStorage.getItem("campaigns");
                if(typeof campaigns === "string") {
                    campaigns.split(",").forEach(campaign => {
                        counter += $this.find('[data-campaigns~="' + campaign + '"]').show().length;
                    });
                }
                if(!counter) {
                    $this.find('[data-campaigns=""]').show();
                }
            });
            var downstream = +sessionStorage.getItem("downstream");
            $target.find(".bandbreiteMax").html(downstream.toLocaleString("de-DE", {useGrouping: true}));
            $target.find(".rateNomen").html($("[data-model]").data("model"));
            var rates = JSON.parse(sessionStorage.getItem("rates"));
            $("[data-for-rates]").removeClass("enabled").each(function(i, e) {
                this.dataset.forRates.split(" ").some(rate => {
                    if(rates.hasOwnProperty(rate) && rates[rate].available) {
                        e.classList.add("enabled");
                        return true;
                    }
                    return false;
                });
                if(e.classList.contains("enabled") && "notWhenRates" in this.dataset) {
                    this.dataset.notWhenRates.split(" ").some(rate => {
                        if(rates.hasOwnProperty(rate) && rates[rate].available) {
                            e.classList.remove("enabled");
                            return true;
                        }
                        return false;
                    });
                }
            });
            $("[data-for-status]").removeClass("enabled").each(function(i, e) {
                this.dataset.forStatus.split(" ").some(status => {
                    if(status === sessionStorage.getItem("status").replace(" ", "-")) {
                        e.classList.add("enabled");
                        return true;
                    }
                    return false;
                });
            });
            $("[data-hide-when-status]").addClass("enabled").each(function(i, e) {
                this.dataset.hideWhenStatus.split(" ").some(status => {
                    if(status === sessionStorage.getItem("status").replace(" ", "-")) {
                        e.classList.remove("enabled");
                        return true;
                    }
                    return false;
                });
            });
            var $linkRate = $("#nominalSpeedHolder");
            if($linkRate.length) {
                var $link = $target.find("#toOrder");
                var href = $link.attr("href");
                if(href && href.indexOf("-") > -1) {
                    href = href.split("-");
                    href.pop();
                    $link.attr("href", href.join("-") + "-" + $linkRate.data("downstream"));
                }
            }
        }

        function display($target, text) {
            if(text) {
                $target.html(text);
            }
            replacePlaceholderByData($target);
            configLayer.postspecial[lastLayerName]?.($target);
            show($target);
            var autoProgress = configLayer.auxiliaryData.autoProgress[location.hash];
            if(autoProgress) {
                indirectResult = false;
                location.hash = autoProgress;
            }
        }

        function openLayer(name, $target = $resultLayer, layerContent) {
            if(typeof layerContent === "string") {
                $runtimeLayerContainer.find(".resulttext").html(layerContent.replace(/\$BANDBREITE/g, '<span class="bandbreiteMax"></span>').replace(/\$TARIFNAME/g, '<span class="rateNomen"></span>'));
                display($target, $runtimeLayerContainer.html());
                lastLayerName = name;
                lastResultLayerName = name;
                lastLayerContent = layerContent;
                $lastResultTarget = $target;
                lastResultLayerHasLayerContent = true;
            } else {
                if(name === lastLayerName && !configLayer.extend.hasOwnProperty(name) && $target === $lastTarget) {        // do not reuse extendable layers (due to them likely receiving dynamic data)
                    return display($target);
                }
                if(name !== "iframe") {
                    lastLayerName = name;                                                       // iframes can have different src, don't reshow if the last also was iframe
                    $lastTarget = $target;
                }
                if(configLayer.auxiliaryData.resultLayer.includes(name)) {
                    if(name !== "iframe" || configLayer.auxiliaryData.iframe[sessionStorage.getItem("iframeKey")].treatAsResultLayer) {
                        lastResultLayerName = name;
                        $lastResultTarget = $target;
                        lastResultLayerHasLayerContent = false;
                    }
                }

                if(configLayer.inline.includes(name)) {
                    display($target, $("#" + name).html());
                } else {
                    if(configLayer.extend.hasOwnProperty(name)) {
                        var query = "&" + configLayer.extend[name]();
                    } else {
                        var query = "";     // assume passthrough
                    }
                    fetch("/wp-content/themes/amplus/templates/partials/layer/wrapper.php?name=" + encodeURIComponent(name) + query).then(response => response.text()).then(text => display($target, text));
                }
            }
        }

        var autocontinue = false;
        var autocheck = false;
        function openLayerAvailabilityCheck() {
            if(sessionStorage.getItem("availabilitychecked") === "true") {
                autocontinue = true;
                setTimeout(() => {          // on deeplink event listeners are not added yet
                    $('[data-name="x-hausnummer"]').val(sessionStorage.getItem("housenumber"));
                    $('[data-name="x-strasse"]').val(sessionStorage.getItem("street"));
                    $('[data-name="x-plz_ort"]').val(sessionStorage.getItem("plzort")).trigger("input").trigger("blur");
                }, 1);
            } else {
                setTimeout(() => {
                    $('[data-name="x-plz_ort"]').focus();
                }, 500);
            }
            show($('#verfuegbarkeit'));
            return true;
        }

        function openHelpLayer() {
            openLayerAvailabilityCheck();
            openLayer("hilfe");
        }

        function showPromotionLayer(event) {
            if(event.type === "touchstart" && this !== event.target) {
                return;
            }
            var $promotion = $("#Promotion");
            if(!$(this).closest(".rate").length) {
                $promotion.addClass("no-promo");
            } else {
                $promotion.removeClass("no-promo");
            }
            $promotion.find(".promotion-layer-content").html(this.dataset.longtext.replace(/\$PROJECT_END/g, sessionStorage.getItem("projectend")));
            var offset = this.getBoundingClientRect();
            $promotion.find(".layer-overflow-container").css({
                "top": (offset.y + this.clientHeight - 8) + "px",
                "left": (offset.x + this.clientWidth/2) + "px"
            });
            show($promotion);
        }

		function openB2XContactLayer(force) {
            var $contactLayer = $('#Kontakt');
            $contactLayer.removeClass($contactLayer.data("forced"));
            if(force) {
                $contactLayer.addClass(force);
                $contactLayer.data("forced", force)
        
                if (force === 'b2b') {
                    $contactLayer.addClass('show-b2b').removeClass('show-b2c');
                }
                else if (force === 'b2c') {
                    $contactLayer.addClass('show-b2c').removeClass('show-b2b');
                }
            }
			show($contactLayer);
		}


        function evalHash(e) {
            indirectResult && closeAllLayer();
            switch(location.hash) {
                case "#termin":
                    sessionStorage.setItem("iframeKey", "termin");
                    sessionStorage.setItem("hashValue", location.hash);
                    sessionStorage.setItem("iframeResult", "true");
                    $("#verfuegbarkeit .js-check-button").text("Terminanfrage prüfen");
                    openLayerAvailabilityCheck();
                    break;
                case "#verfuegbarkeit":
                    sessionStorage.setItem("iframeResult", "false");
                    $("#verfuegbarkeit .js-check-button").text("Verfügbarkeit prüfen");
                    openLayerAvailabilityCheck();
                    break;
                case "#keineverfuegbarkeit":
                    sessionStorage.setItem("iframeKey", "keineverfuegbarkeit");
                    sessionStorage.setItem("hashValue", location.hash);
                    sessionStorage.setItem("iframeResult", "true");
                    openLayerAvailabilityCheck();
                    openLayer("iframe");
                    break;
                case "#Kontakt":
                    openB2XContactLayer();
                    break;
                case "#Kontakt-B2C":
                    openB2XContactLayer("b2c");
                    break;
                case "#Kontakt-B2B":
                    openB2XContactLayer("b2b");
                    break;
                case "#hilfe":
                    openHelpLayer();
                    break;
                case "#tarifzurwahl":
                    removeHash();
                    break;
                case "#Termin-Anfrage":
                case "#Ergebnis":
                    if(!availabilityResultIsValid) {
                        openLayerAvailabilityCheck();
                        if(e && e.oldURL.split("#")[0] === location.href.split("#")[0]) {
                            if(autocontinue) {
                                setTimeout(() => {
                                    var $checkButton = $(".js-check-button");
                                    if(!$checkButton.is(":disabled")) {
                                        $checkButton.click();
                                    }
                                }, 750);
                            } else {
                                history.back();
                            }
                        } else {
                            if(autocontinue) {
                                autocheck = true;
                            } else {
                                if(sessionStorage.getItem("iframeResult") !== "true") {
                                    $("#verfuegbarkeit .js-check-button").text("Verfügbarkeit prüfen");
                                    history.replaceState({}, "", "#verfuegbarkeit");
                                } else {
                                    $("#verfuegbarkeit .js-check-button").text("Terminanfrage prüfen");     // Text depends on type of iframe! not implemented here because only 1 iframe type yet
                                    history.replaceState({}, "", sessionStorage.getItem("hashValue"));
                                }
                            }
                        }
                    } else {
                        indirectResult && openLayerAvailabilityCheck() && openLayer(lastResultLayerName, $lastResultTarget, lastResultLayerHasLayerContent ? lastLayerContent : 0);
                        indirectResult = true;
                    }
                    break;
                default:
                    try {
                        let layer = $(location.hash + ".layer");
                        (location.hash.length > 1 && layer.length > 0) ? show(layer) : 0;
                    } catch(e) { }
            }
        }
		addEventListener("hashchange", evalHash);
        evalHash();
		
		
        /**
         *  availability - check
         */
        // assume there is only 1 and the same availability check form on the page
        var $plzOrt = $('input[data-name="x-plz_ort"]');
        var $strasse = $('input[data-name="x-strasse"]');
        var $hausnummer = $('input[data-name="x-hausnummer"]');

        var rebuild = false;
        var rebuildAt = +sessionStorage.getItem("rebuildAvailabilityData");
        if(!isNaN(rebuildAt)) {                     // we don't use rebuildAt === 0 as keep forever here, rather we use it as do rebuild (see "recheck")
            rebuildAt -= new Date().getTime();
            if (rebuildAt <= 0) {
                rebuild = true;
                sessionStorage.removeItem("rebuildAvailabilityData");
            }
        }

        var evalAutoSuggestsCore = {
            "plz_ort": {
                counter: 0,
                lastHandledCounter: 0,
                lastSuccessVal: -1,
                valSuggested: false,
                waitingForData: true,
                continueBlurCheck: null,
                data: function(val, evaluator) {
                    val = val.toLocaleLowerCase();
                    if(evalAutoSuggestsCore["plz_ort"].history.hasOwnProperty(val)) {
                        evaluator(evalAutoSuggestsCore["plz_ort"].history[val]);
                    } else {
                        for(var key in evalAutoSuggestsCore["plz_ort"].history) {           // check if current value is a completing string of an entry for which we have the date already. If it is, use the autocomplete suggestions of that which are also extending it. (Assuming the autosuggests of that contain all possible completions.)
                            if(val.indexOf(key) === 0 || val.substring(val.indexOf(" ") + 1).indexOf(key) === 0) {                                    // do not check key city separate from zip because key city depends on zip and if only a val city was entered that can be the superstring of the key city of another zip but which are not all cities beginning with that val
                                evalAutoSuggestsCore["plz_ort"].history[val.trim()] = evalAutoSuggestsCore["plz_ort"].history[key].filter(function(e) {
                                    return e.toLocaleLowerCase().indexOf(val) === 0 || e.toLocaleLowerCase().substring(e.indexOf(" ") + 1).indexOf(val) === 0;
                                });
                                return evaluator(evalAutoSuggestsCore["plz_ort"].history[val.trim()]);
                            }
                        }
                        $.get({
                            url: "/wp-json/leo/v1/availability/cities/" + encodeURIComponent(val),
                            success: function(data) {
                                if(data.data && data.data.status) {
                                    if(data.data.status != 404) {
                                        if(confirm("Es ist ein Fehler aufgetreten, bitte versuchen Sie es noch mal.\n\nSollte der Fehler erneut auftreten kontaktieren Sie bitte unseren Support.\n\nKlicken Sie OK, um Kontaktmöglichkeiten anzuzeigen")) {
                                            location.href = "#Kontakt";
                                        }
                                    }
                                    evaluator([]);
                                } else {
                                    evaluator(data);
                                    evalAutoSuggestsCore["plz_ort"].history[val.trim()] = data;
                                    sessionStorage.setItem("availabilityhistoryplzort", JSON.stringify(evalAutoSuggestsCore["plz_ort"].history));
                                }
                            },
                            error: function(jqXHR) {
                                if(jqXHR.status != 404) {
                                    if(confirm("Es ist ein Fehler aufgetreten, bitte versuchen Sie es noch mal.\n\nSollte der Fehler erneut auftreten kontaktieren Sie bitte unseren Support.\n\nKlicken Sie OK, um Kontaktmöglichkeiten anzuzeigen")) {
                                        location.href = "#Kontakt";
                                    }
                                }
                                evaluator([]);
                            }
                        });
                    }
                },
                history: rebuild ? {} : JSON.parse(sessionStorage.getItem("availabilityhistoryplzort") || "{}"),
                core: function(data, $autosuggests) {
                    data.forEach(function(datum) {
                        $autosuggests.append("<div class='dropdown-item' data-val='" + datum.replace("'", "&#39;") + "' tabindex='-1'>" + datum + "</div>");
                    });
                },
                click: function(e) {
                    e.stopPropagation();
                    var $this = $(this);
                    var newVal = $this.data("val").replace("&#39;", "'");
                    if(newVal !== evalAutoSuggestsCore["plz_ort"].lastSuccessVal) {
                        evalAutoSuggestsCore["plz_ort"].lastSuccessVal = newVal;
                        availabilityCheckData["strasseNummer"].data = [];
                        if(availabilityCheckData["strasseNummer"].history.hasOwnProperty(newVal.toLocaleLowerCase())) {
                            availabilityCheckData["strasseNummer"].data = availabilityCheckData["strasseNummer"].history[newVal.toLocaleLowerCase()];
                            enableInput($strasse);
                            //if(availabilityCheckData.tabWaitingFrom === "plz_ort") {
                                $strasse[0].focus();
                                if(autocontinue) {
                                    $strasse.trigger("focus");
                                    setTimeout(() => {
                                        $strasse.trigger("blur");
                                    }, 1);
                                }
                            //}
                        } else {
                            $.get({
                                url: "/wp-json/leo/v1/availability/streets/" + encodeURIComponent(newVal),
                                success: (function() {
                                    var currentCount = ++(availabilityCheckData["strasseNummer"].counter);
                                    return function(data) {
                                        if(data.data && data.data.status) {
                                            if(confirm("Es ist ein Fehler aufgetreten beim Holen der möglichen Straßennamen und Hausnummern,\nbitte versuchen Sie es noch mal (ändern Sie den 'PLZ Ort' Feldinhalt oder betreten und verlassen Sie das 'PLZ Ort' Feld).\n\nSollte der Fehler erneut auftreten kontaktieren Sie bitte unseren Support.\n\nKlicken Sie OK, um Kontaktmöglichkeiten anzuzeigen")) {
                                                location.href = "#Kontakt";
                                            }
                                            evaluator([]);
                                        } else {
                                            availabilityCheckData["strasseNummer"].history[newVal.toLocaleLowerCase()] = data;
                                            sessionStorage.setItem("availabilityhistorystrassenhausnummer", JSON.stringify(availabilityCheckData["strasseNummer"].history));
                                            keepStreetsAndNumbers(data, $plzOrt, newVal, currentCount);
                                            if(autocontinue) {
                                                $strasse.trigger("focus");
                                                setTimeout(() => {
                                                    $strasse.trigger("blur");
                                                }, 1);
                                            }
                                        }
                                    }
                                })(),
                                error: function() {
                                    if(confirm("Es ist ein Fehler aufgetreten beim Holen der möglichen Straßennamen und Hausnummern,\nbitte versuchen Sie es noch mal (ändern Sie den 'PLZ Ort' Feldinhalt oder betreten und verlassen Sie das 'PLZ Ort' Feld).\n\nSollte der Fehler erneut auftreten kontaktieren Sie bitte unseren Support.\n\nKlicken Sie OK, um Kontaktmöglichkeiten anzuzeigen")) {
                                        location.href = "#Kontakt";
                                    }
                                }
                            });
                        }
                        demarkInputSuccess($strasse);
                        demarkInputSuccess($hausnummer);
                        $this.closest(".verfuegbarkeitsabfrage-container").find(".js-check-button").addClass("disabled").attr("disabled", "");
                        if(!autocontinue) {
                            $strasse.val("").attr("data-val", "");
                            $hausnummer.val("").attr("data-val", "");
                            disableInput($hausnummer);
                        }
                    } else {
                        enableInput($strasse);
                        //if(availabilityCheckData.tabWaitingFrom === "plz_ort") {
                            $strasse[0].focus();
                        //}
                    }
                    $plzOrt.val(newVal);
                    evalAutoSuggestsCore["plz_ort"].valSuggested = true;
                    hide($this.closest(".js-autosuggest-container"));
                    markInputSuccess($plzOrt);
                }
            },
            "strasse": {
                counter: 0,
                lastHandledCounter: 0,
                lastSuccessVal: -1,
                valSuggested: false,
                waitingForData: false,
                continueBlurCheck: null,
                data: function(val) {
                    function synonym(text) {
                        return text.replace(/ß/g, "s").replace(/ss/g, "s").replace(/str(?=a)?(a(?=s)?(s(?=e)?(e)?)?)?$/, "str").replace(/-/g, "").replace(/ /g, "").replace(/\./g, "");
                    }
                    return availabilityCheckData["strasseNummer"].data.filter(function(e, i, a) {
                        if(synonym(e.street.toLocaleLowerCase()).indexOf(synonym(val.toLocaleLowerCase())) === 0) {
                            a[i].originalIndex = i;
                            return true;
                        }
                    });
                },
                core: function(data, $autosuggests) {
                    data.forEach(function(datum) {
                        $autosuggests.append("<div class='dropdown-item' data-val='" + datum.street.replace("'", "&#39;") + "' data-originalindex='" + datum.originalIndex + "' tabindex='-1'>" + datum.street + "</div>");
                    });
                },
                click: function(e) {
                    e.stopPropagation();
                    var $this = $(this);
                    var newVal = $this.data("val").replace("&#39;", "'");
                    if(newVal !== evalAutoSuggestsCore["strasse"].lastSuccessVal) {
                        evalAutoSuggestsCore["strasse"].lastSuccessVal = newVal;
                        availabilityCheckData["nummer"].data = availabilityCheckData["strasseNummer"].data[$this.data("originalindex")].house_numbers.split(",").sort(function(a, b) {
                            var intA = parseInt(a, 10);
                            if(isNaN(intA)) {               // a does not begin with number, assume letter
                                intA = 999999 + a.toLocaleLowerCase().charCodeAt(0);     // compare letters by charcode, sort letters after numbers
                            }
                            var intB = parseInt(b, 10);
                            if(isNaN(intB)) {               // b does not begin with number, assume letter
                                intB = 999999 + b.toLocaleLowerCase().charCodeAt(0);     // compare letters by charcode, sort letters after numbers
                            }
                            if(intA === intB) {             //take letters after the number into consideration
                                var secondComparison = "";
                                if(intA + "" !== a) {           // if a contains additional non-numeric characters after numeric characters this is true
                                    var secondComparison = a.substring((intA + "").length).trim().toLocaleLowerCase();
                                }
                                var secondComparison2 = "";
                                if(intB + "" !== b) {           // if b contains additional non-numeric characters after numeric characters this is true
                                    var secondComparison2 = b.substring((intB + "").length).trim().toLocaleLowerCase();
                                }
                                if(secondComparison < secondComparison2) {
                                    return -1;
                                }
                                if(secondComparison > secondComparison2) {
                                    return 1;
                                }
                                return 0;
                            }
                            return intA - intB;
                        });
                        demarkInputSuccess($hausnummer);
                        if(!autocontinue) {
                            $hausnummer.val("").attr("data-val", "");
                        }
                        $this.closest(".verfuegbarkeitsabfrage-container").find(".js-check-button").addClass("disabled").attr("disabled", "");
                    }
                    $strasse.val(newVal);
                    evalAutoSuggestsCore["strasse"].valSuggested = true;
                    hide($this.closest(".js-autosuggest-container"));
                    markInputSuccess($strasse);
                    enableInput($hausnummer);
                    //if(availabilityCheckData.tabWaitingFrom === "strasse") {
                        $hausnummer[0].focus();
                        if(autocontinue) {
                            $hausnummer.trigger("focus");
                            setTimeout(() => {
                                $hausnummer.trigger("blur");
                            }, 1);
                        }
                    //}
                    if(availabilityCheckData["nummer"].data.length === 1 && availabilityCheckData["nummer"].data[0].trim() === "0") {
                        $hausnummer.val("0");
                        $hausnummer[0].focus();
                        $hausnummer[0].dispatchEvent(new Event("input"));
                        var evTab = new Event("keydown");
                        evTab.which = 9;
                        $hausnummer[0].dispatchEvent(evTab);
                        setTimeout(function() {
                            setTimeout(function() {
                            }, 5000);
                        }, 500);
                    }
                }
            },
            "hausnummer": {
                counter: 0,
                lastHandledCounter: 0,
                lastSuccessVal: -1,
                valSuggested: false,
                waitingForData: false,
                continueBlurCheck: null,
                data: function(val) {
                    return availabilityCheckData["nummer"].data.filter(function(e, i, a) {
                        if(e.toLocaleLowerCase().indexOf(val.toLocaleLowerCase()) === 0) {
                            return true;
                        }
                    });
                },
                core: function(data, $autosuggests) {
                    data.forEach(function(datum) {
                        $autosuggests.append("<div class='dropdown-item' data-val='" + datum.replace("'", "&#39;") + "' tabindex='-1'>" + datum + "</div>");
                    });
                },
                click: function(e) {
                    e.stopPropagation();
                    var $this = $(this);
                    var newVal = $this.attr("data-val").replace("&#39;", "'");
                    $hausnummer.val(newVal);
                    evalAutoSuggestsCore["hausnummer"].valSuggested = true;
                    var $checkButton = $this.closest(".verfuegbarkeitsabfrage-container").find(".js-check-button").removeClass("disabled").removeAttr("disabled");
                    //if(availabilityCheckData.tabWaitingFrom === "hausnummer") {
                        $checkButton[0].focus();
                        autocontinue = false;
                        if(autocheck) {
                            autocheck = false;
                            $checkButton.click();
                        }
                    //}
                    hide($this.closest(".js-autosuggest-container"));
                    markInputSuccess($hausnummer);
                }
            }
        };
        var availabilityCheckData = {
            "strasseNummer": {
                counter: 0,
                lastHandledCounter: 0,
                data: [],
                history: rebuild ? {} : JSON.parse(sessionStorage.getItem("availabilityhistorystrassenhausnummer") || "{}")
            },
            "nummer": {
                data: []
            },
            "current": "",
            "tabWaitingFrom": ""                // Tabulator key handling storage
        };

        function keepStreetsAndNumbers(data, $src, forVal, requestNumber) {
            if($src.val() === forVal) {       // only accept if current input is exactly the input for which the data is
                if(requestNumber > availabilityCheckData["strasseNummer"].lastHandledCounter) {            // dismiss replies to requests of which a successor has already been handled
                    availabilityCheckData["strasseNummer"].lastHandledCounter = requestNumber;
                    availabilityCheckData["strasseNummer"].data = data;
                    enableInput($strasse);
                    //if(availabilityCheckData.tabWaitingFrom === "plz_ort") {
                        $strasse[0].focus();
                    //}
                }
            }
        }

        var pressedShiftKey = false;

        document.body.addEventListener("keydown", function(e) {
            pressedShiftKey = e.shiftKey;
        });
        document.body.addEventListener("keyup", function() {
            pressedShiftKey = false;
        });

        function evalAutosuggests(data, $src, forVal, requestNumber, coreType) {
            if(forVal.toLocaleLowerCase() === $src.val().toLocaleLowerCase()) {                     // only show if current input is identical the string for which autosuggests were found
                var $autosuggests = $src.closest(".input-container").find(".js-autosuggest-container");
                if($autosuggests.data("forvalue") !== forVal) {
                    $autosuggests.data("forvalue", forVal);
                    function handleClick(e) {
                        var $ddI = $(e.target).closest(".dropdown-item");
                        if($ddI.length) {
                            $src.attr("data-val", $ddI.data("val"));
                            evalAutoSuggestsCore[coreType].click.call($ddI[0], e);
                        }
                    }
                    $autosuggests.off("click");     // remove all click handlers, we only assigned handleClick but that local (= "dynamically created") function doesn't get removed when explicitly passed (anymore)
                    if(data.length < 1) {
                        $autosuggests.empty();
                        $autosuggests.append("<div class='dropdown-item' data-val=''>keine Übereinstimmung gefunden</div>");
                        show($autosuggests);
                    } else {
                        if(requestNumber > evalAutoSuggestsCore[coreType].lastHandledCounter) {         // dismiss replies to requests of which a successor has already been handled
                            evalAutoSuggestsCore[coreType].lastHandledCounter = requestNumber;
                            $autosuggests.empty();
                            evalAutoSuggestsCore[coreType].core(data, $autosuggests);
                            $autosuggests.on("click", handleClick);
                            if(coreType === availabilityCheckData["current"]) {
                                show($autosuggests);
                            }
                        }
                    }
                } else {
                    if(data.length < 1 || requestNumber > evalAutoSuggestsCore[coreType].lastHandledCounter && coreType === availabilityCheckData["current"]) {
                        show($autosuggests);
                    }
                }
            }
            if(requestNumber === evalAutoSuggestsCore[coreType].counter) {
                evalAutoSuggestsCore[coreType].waitingForData = false;
                if(typeof evalAutoSuggestsCore[coreType].continueBlurCheck === "function") {
                    evalAutoSuggestsCore[coreType].continueBlurCheck();
                    evalAutoSuggestsCore[coreType].continueBlurCheck = null;
                }
            }
        }

        function evalInput(e) {
            var $this = $(this);
            var val = $this.val();
            var name = $this.attr("data-name").substring("x-".length);
            var processedVal = val.replace("'", "&#39;");
            if($this.attr("data-val")?.toLocaleLowerCase() !== processedVal.toLocaleLowerCase()) {
                demarkInputSuccess($this);
                availabilityResultIsValid = false;
            }
            $this.attr("data-val", processedVal);      // for styling to style the label based on whether input present
            evalAutoSuggestsCore[name].valSuggested = false;        // new input = the value is (for first) not from autosuggest (and needs to be checked on blur)
            availabilityCheckData.tabWaitingFrom = "";
            if(val.length > 0) {
                hide($this.closest(".input-container").find(".js-autosuggest-container"));
                evalAutoSuggestsCore[name].waitingForData = true;
                availabilityCheckData["current"] = name;
                var dataEvaluationClosure = (function() {
                    var currentCount = ++(evalAutoSuggestsCore[name].counter);
                    return function(data) {
                        evalAutosuggests(data, $this, val, currentCount, name);
                    }
                })();
                if($this.attr("data-async") === "") {
                    evalAutoSuggestsCore[name].data(val, dataEvaluationClosure);
                } else {
                    dataEvaluationClosure(evalAutoSuggestsCore[name].data(val));
                }
            }
        }

        function checkAutosuggests(e) {
            if(pressedShiftKey) {                                                               // disregard blur when shift pressed (eg shift tab = going back)
                hide($(e.currentTarget).closest(".input-container").find(".js-autosuggest-container"));
                return;
            }
            var $this = $(e.currentTarget);
            var name = $this.attr("data-name").substring("x-".length);
            if($(e.relatedTarget).closest(".js-autosuggest-container").length < 1) {            // if we don't click the autosuggest container (content), treat it as blur
                var val = $this.val();
                availabilityCheckData["current"] = "";
                var $autosuggests = $this.closest(".input-container").find(".js-autosuggest-container");
                if(!evalAutoSuggestsCore[name].valSuggested) {      // the value is not from autosuggest (and needs to be checked)
                    function completeBlurCheck() {
                        if(availabilityCheckData["current"] !== name) {     // the blurred one has not been reentered (after blurring and before for example the autosuggest data arrived)
                            var counter = 0;
                            var valLC = val.toLocaleLowerCase();
                            if(valLC.length) {
                                var first = $autosuggests.children().first();
                                if(first.attr("data-val") !== "") {           // firstVal can be "" from "no matches found" case
                                    first[0].click();
                                    return false;
                                }
                                /*
                                var children = $autosuggests.children();
                                var numSuggests = children.each(function() {
                                    if($(this).attr("data-val").replace("&#39;", "'").toLocaleLowerCase() === valLC) {
                                        this.click();
                                        return false;
                                    }
                                    counter++;
                                }).length;
                                if(numSuggests === 1) {
                                    var first = children.first();
                                    var firstVal = first.attr("data-val").replace("&#39;", "'").toLocaleLowerCase();
                                    if(firstVal.length && (firstVal.indexOf(valLC) === 0 || name === "plz_ort" && firstVal.substring(firstVal.indexOf(" ") + 1).indexOf(valLC) === 0)) {           // firstVal can be "" from "no matches found" case
                                        first.click();
                                        return false;
                                    }
                                }
                                */
                            } else {
                                var numSuggests = 0;
                            }
                            if(true || counter === numSuggests) {       // no matching autosuggest found
                                var $availabilityContainer = $this.closest(".verfuegbarkeitsabfrage-container");
                                switch (name) {
                                    case "plz_ort":
                                        demarkInputSuccess($plzOrt);
                                        demarkInputSuccess($strasse);
                                        demarkInputSuccess($hausnummer);
                                        //$plzOrt.val("").attr("data-val", "");
                                        $strasse.val("").attr("data-val", "");
                                        $hausnummer.val("").attr("data-val", "");
                                        disableInput($strasse);
                                        disableInput($hausnummer);
                                        // $plzOrt[0].focus();                              // do not focus, prevents entering a previous field does not work
                                        break;
                                    case "strasse":
                                        demarkInputSuccess($strasse);
                                        demarkInputSuccess($hausnummer);
                                        //$strasse.val("").attr("data-val", "");
                                        $hausnummer.val("").attr("data-val", "");
                                        disableInput($hausnummer);
                                        // $strasse[0].focus();                             // do not focus, prevents entering a previous field does not work
                                        break;
                                    case "hausnummer":
                                        demarkInputSuccess($hausnummer);
                                        //$hausnummer.val("").attr("data-val", "");
                                        // $hausnummer[0].focus();                          // do not focus, prevents entering a previous field does not work
                                        break;
                                }
                                $availabilityContainer.find(".js-check-button").addClass("disabled").attr("disabled", "");
                            }
                            hide($autosuggests);
                        }
                    }
                    if(evalAutoSuggestsCore[name].waitingForData) {
                        disableInput($strasse);                 // a user shouldn't modify data which might become invalid once the autosuggest data is present
                        disableInput($hausnummer);              // (we know this can only occur for plz_ort thus disable all inputs after)
                        evalAutoSuggestsCore[name].continueBlurCheck = completeBlurCheck;
                    } else {
                        if($autosuggests.children().length < 1) {       // if no autosuggest entry is present (note: there is at least "no data present" entry, except if we wait for the data)
                            // having no entry but not waiting should not occur, there should always be at least "no entry present"
                        } else {
                            completeBlurCheck();
                        }
                    }
                }
                hide($autosuggests);
            }
            var $form = $this.closest(".verfuegbarkeitsabfrage-container");
            switch (name) {
                case "plz_ort":
                    $form.find('input[data-name="x-strasse"]').closest(".input-container").find(".js-autosuggest-container").data("forvalue", "");
                    $form.find('input[data-name="x-hausnummer"]').closest(".input-container").find(".js-autosuggest-container").data("forvalue", "");
                    break;
                case "strasse":
                    $form.find('input[data-name="x-hausnummer"]').closest(".input-container").find(".js-autosuggest-container").data("forvalue", "");
                    break;
                case "hausnummer":
                    break;
            }
        }
        function evalTab(e) {
            if((e.which === 13 || (e.which === 9 && !e.shiftKey)) && this.value.length > 0) {
                availabilityCheckData.tabWaitingFrom = this.getAttribute("data-name").substring("x-".length);
                e.preventDefault();
                this.blur();
            }
        }
        $plzOrt.on("input", evalInput).on("focus", evalInput).on("blur", checkAutosuggests).on("keydown", evalTab);             // focus let evalInput to receive autosuggests when input present
        $strasse.on("input", evalInput).on("focus", evalInput).on("blur", checkAutosuggests).on("keydown", evalTab);            // focus let evalInput to receive autosuggests when input present
        $hausnummer.on("input", evalInput).on("focus", evalInput).on("blur", checkAutosuggests).on("keydown", evalTab);         // focus let evalInput to receive autosuggests when input present
        function clearTabWaiting() {
            availabilityCheckData.tabWaitingFrom = "";
        }
        $("body").on("click", clearTabWaiting);


        function track(availabilitySuccess, availabilityData) {
            if(typeof dataLayer !== "undefined") {
                dataLayer.push({
                    "event": availabilitySuccess ? "verfuegbarkeit_positiv" : "verfuegbarkeit_negativ",
                    "kunden_kategorie": document.body.classList.contains("b2b") ? "B2B" : "B2C",
                    "vermarktungsstatus": availabilityData.status,
                    "standort": availabilityData.postal_code + " " + availabilityData.city,
                    "gfha_anschlusspreis": availabilityData.campaigns.substring(3, availabilityData.campaigns.length - 3),
                    "aktionscode": availabilityData.promotion,
                    "aktionsname": availabilityData.promotion_tracking_title
                });
            }
        }


        function requestAvailability(event) {
            var button = this;
            button.classList.add("loading");
            
            document.cookie = "promo=;path=/;Max-Age=0";

            var plzOrt = $plzOrt.val();
            var street = $strasse.val();
            var hausnummer = $hausnummer.val();

            function getAvailabilityResult (plzOrt, street, hausnummer, captchaResponse) {
                $.get({
                    url: "/wp-json/leo/v1/availability/bandwidths/" + encodeURIComponent(plzOrt) + "/" + encodeURIComponent(street) + "/" + encodeURIComponent(hausnummer) + "/" + encodeURIComponent(captchaResponse),
                    success: function(data) {
                        grecaptcha.reset(LEOCaptchaWidgetId);
                        if(data.data && data.data.status) {
                            if(confirm("Es ist ein Fehler aufgetreten, bitte versuchen Sie es noch mal.\n\nSollte der Fehler erneut auftreten kontaktieren Sie bitte unseren Support.\n\nKlicken Sie OK, um Kontaktmöglichkeiten anzuzeigen")) {
                                location.href = "#Kontakt";
                            }
                        } else {
                            sessionStorage.setItem("street", data.street);
                            sessionStorage.setItem("housenumber", data.house_number);
                            sessionStorage.setItem("plzort", plzOrt);
                            sessionStorage.setItem("plz", data.postal_code);
                            sessionStorage.setItem("ort", data.city);
                            sessionStorage.setItem("key", data.key);
                            sessionStorage.setItem("campaigns", data.campaigns);
                            sessionStorage.setItem("gfha", data.gfha);
                            sessionStorage.setItem("rates", JSON.stringify(data.rates));
                            sessionStorage.setItem("projectend", data.project_end);
                            sessionStorage.setItem("datasource", data.data_source);
                            sessionStorage.setItem("district", data.district);
                            sessionStorage.setItem("companydata", JSON.stringify(data.company_data));
                            if(data.promotion) {
                                sessionStorage.setItem("promotion", data.promotion);
                                document.cookie = "promo=" + data.promotion + ";path=/";
                                document.cookie = "promo-doa=1;path=/";
                            }
                            var recheckAt = new Date().getTime() + data.recheck;
                            sessionStorage.setItem("recheck", recheckAt);
                            if(!sessionStorage.getItem("rebuildAvailabilityData")) {
                                sessionStorage.setItem("rebuildAvailabilityData", recheckAt);
                            }
                            sessionStorage.setItem("bestatus", data.status);
                            var status = configMappingAvailabilityStatus[data.status] ?? data.status;
                            sessionStorage.setItem("status", status);
                            var connectionTypes = data.connection_types;
                            sessionStorage.setItem("connectionTypes", connectionTypes.join(","));
                            var downstream = data.downstream;
                            if(typeof downstream !== "number") {
                                downstream = 0;
                            }
                            sessionStorage.setItem("downstream", downstream);
                            document.cookie = "availabilitychecked=1;path=/";
                            sessionStorage.setItem("availabilitychecked", "true");
                            availabilityResultIsValid = true;
                            var available = "tbd";
                            var yetToOpenLayer = false;     // for actOnAvailabilityPresent
                            var layerNotYetOpened = true;   // for inside here
                            var inb2b = document.body.classList.contains("b2b");
                            var noGFHA = ["not planned", "area planned"].includes(status);
                            // implementation according to https://miro.com/app/board/uXjVODcJFNM=/?moveToWidget=3458764586640865543&cot=14
                            if(!document.body.classList.contains("single-landing") || !document.querySelector("#LandingPageSpecificErgebnisLayerContainer")) {
                                if(downstream !== 0 && sessionStorage.getItem("iframeResult") === "true") {
                                    openLayer("iframe");
                                    layerNotYetOpened = false;
                                } else if(downstream === 0 && data.campaigns) {
                                    openLayer("spezial");
                                    layerNotYetOpened = false;
                                    sessionStorage.setItem("showFeedback", "zero");
                                } else if(!inb2b && data.message_b2c?.length) {
                                    openLayer("", $resultLayer, data.message_b2c);
                                    layerNotYetOpened = false;
                                } else if(inb2b && data.message_b2b?.length) {
                                    openLayer("", $resultLayer, data.message_b2b);
                                    layerNotYetOpened = false;
                                }
                                
                                if(!["nvm tif"].includes(status) && (!noGFHA || downstream === 0) && !inb2b) {
                                    layerNotYetOpened ? openLayer(noGFHA ? "gfha-nicht-moglich" : "gfha-moglich") : 0;
                                    sessionStorage.setItem("showFeedback", "gfha");
                                } else if(downstream === 0) {
                                    if(layerNotYetOpened) {
                                        openLayer("downstream-0");
                                    }
                                    sessionStorage.setItem("showFeedback", "zero");
                                } else if(document.body.classList.contains("rates-template-rates-detail")) {
                                    yetToOpenLayer = layerNotYetOpened;     // delayed because we must determine "FE availability" (= available) on the page on load also and it is the same code
                                    sessionStorage.setItem("showFeedback", "true");
                                } else {
                                    layerNotYetOpened ? !connectionTypes.includes("ftth") ? openLayer("fttc-verfugbar") : openLayer("ftth-verfugbar") : 0;
                                    sessionStorage.setItem("showFeedback", "true");
                                }
                            } else {
                                if(downstream === 0) {
                                    // downstream 0
                                    if(data.campaigns) {
                                        // campaign is set for address
                                        openLayer("spezial");
                                    } else {
                                        openLayer("downstream-0");
                                    }
                                    sessionStorage.setItem("showFeedback", "zero");
                                } else if(sessionStorage.getItem("iframeResult") === "true") {
                                    openLayer("iframe");
                                    sessionStorage.setItem("showFeedback", "true");
                                } else if(typeof landingDownstreamMin === "number" && typeof landingDownstreamMax === "number" && downstream >= landingDownstreamMin && downstream <= landingDownstreamMax && typeof offerstatus !== "undefined" && Array.isArray(offerstatus) && !offerstatus.includes(data.status)) {
                                    openLayer("status-nicht-fur-aktion");
                                    available = "restricted";
                                    sessionStorage.setItem("showFeedback", "true");
                                } else {
                                    openLayer("LandingPageSpecificErgebnisLayerContainer");
                                    sessionStorage.setItem("showFeedback", "true");
                                }
                            }
                            if(event.originalEvent?.isTrusted) {
                                track(downstream !== 0, data);
                            }
                            sessionStorage.setItem("available", available);
                            actOnAvailabilityPresent(yetToOpenLayer);
                        }
                        button.classList.remove("loading");
                    },
                    error: function(jqXHR, textStatus, errorThrown) {
                        grecaptcha.reset(LEOCaptchaWidgetId);
                        if(jqXHR.responseJSON.code === "invalid_captcha") {
                            alert("Die Verifikation, dass Sie kein Roboter sind, ist fehlgeschlagen.\n\nBitte schicken Sie die Anfrage erneut ab.");
                        } else {
                            if(confirm("Es ist ein Fehler aufgetreten, bitte versuchen Sie es noch mal.\n\nSollte der Fehler erneut auftreten kontaktieren Sie bitte unseren Support.\n\nKlicken Sie OK, um Kontaktmöglichkeiten anzuzeigen")) {
                                location.href = "#Kontakt";
                            }
                        }
                        button.classList.remove("loading");
                    }
                });
            }

            function completer() {
                LEOCaptchaCompleter.push((function(plzOrt, street, hausnummer) {
                    return function(captchaResponse) {
                        getAvailabilityResult (plzOrt, street, hausnummer, captchaResponse);
                    }
                })(plzOrt, street, hausnummer));
                grecaptcha.execute(LEOCaptchaWidgetId);
            }
            if(LEOCaptchaReady) {
                completer();
            } else {
                LEOCaptchaQueue.push(completer);
            }
        }
        $(".js-check-button").on("click", requestAvailability);


        /**
         *  availability - act on (page load)
         */
        var clearSessionTimeout = null;
        function actOnAvailabilityPresent(yetToOpenLayer) {
            keepDataUpToDate();

            if(LEOCookies["availabilitychecked"] === "1") {
                if(sessionStorage.getItem("availabilitychecked") === "true") {
                    var downstream = sessionStorage.getItem("downstream");
                    var status = sessionStorage.getItem("status");
                    var street = sessionStorage.getItem("street");
                    var housenumber = sessionStorage.getItem("housenumber");
                    var plzort = sessionStorage.getItem("plzort");
                    var rates = JSON.parse(sessionStorage.getItem("rates"));
                    var available = sessionStorage.getItem("available");
                    var code = sessionStorage.getItem("promotion");
                    
                    $(".js-duedate-countdown").each(function() {
                        if(this.dataset.duelimit.split(",").includes(code)) {
                            this.classList.add("do-countdown");
                        }
                    });

                    if(rates) {
                        var index = 1;
                        $(".rate[data-articleid]:not([data-for-rates])").each(function() {
                            if(rates.hasOwnProperty(this.dataset.articleid)) {
                                this.classList.add("js-presentable");
                                this.dataset.index = "" + index++;
                                if(rates[this.dataset.articleid].available) {
                                    this.classList.remove("rate-availability-not-given");
                                    this.classList.add("js-rate-availability-given");
                                } else {
                                    this.classList.remove("js-rate-availability-given");
                                    this.classList.add("rate-availability-not-given");
                                }
                            } else {
                                this.classList.remove("js-presentable");
                                this.classList.remove("js-rate-availability-given");
                                this.classList.add("rate-availability-not-given");
                            }
                        });
                    } else {
                        rates = {};
                    }

                    var rateFeedbacks = document.querySelectorAll(".tarif-rckmeldung");
                    if(rateFeedbacks.length) {
                        hide($(".tarif-rckmeldung"));
                        switch(sessionStorage.getItem("showFeedback")) {
                            case "gfha":
                                var $toshow = $('.tarif-rckmeldung[gfha="' + status + '"]');
                                if($toshow.length) {
                                    show($toshow);
                                };
                                break;
                            case "true":
                                show($(".tarif-rckmeldung.has-downstream"));
                                break;
                            case "zero":
                                show($(".tarif-rckmeldung.has-no-downstream"));
                                break;
                            default:
                        }
                            
                        var shown = 0;
                        rateFeedbacks.forEach((rateFeedback) => {
                            if(rateFeedback.classList.contains("shown")) {
                                ++shown;
                                rateFeedback.innerHTML = rateFeedback.innerHTML.replace(/ADRESSEHIER/g, "<span class='addressplacement'></span>");
                                var $rateFeedback = $(rateFeedback);
                                $rateFeedback.find(".addressplacement").html(street + " " + housenumber + ", " + plzort);
                                $rateFeedback.find(".bandbreiteMax").html(downstream);
                            }
                        });
                        
                        if(shown) {
                            showIgnoreSubs($(".tarif-rckmeldungen"));
                            document.body.classList.add("rate-feedback-active");
                        } else {
                            hide($(".tarif-rckmeldungen"));
                            document.body.classList.remove("rate-feedback-active");
                        }
                    }
                    $(".user-checked-data").html(street + " " + housenumber + ", " + plzort);


                    $("body").removeClass("availability-not-given availability-given availability-restricted");

                    if(available === "restricted") {
                        $("body").addClass("availability-restricted");  // this is an extra, not an exclusive extra
                    }

                    if(document.body.classList.contains("rates-template-rates-detail")) {
                        let rateid = $("[data-articleid]").attr("data-articleid");
                        let area = document.body.classList.contains("b2b") ? "b2b" : "b2c";
                        let found = false;
                        if($(".rate-detail-content[data-type]").data("type") === "fttc") {
                            for(let rate in rates) {
                                if(rate !== rateid) {
                                    let ratedata = rates[rate];
                                    if(ratedata.available && ratedata.type === "ftth" && ratedata.category === area) {
                                        found = true;
                                        break;
                                    }
                                }
                            }
                        }
                        if(found) {
                            yetToOpenLayer ? openLayer("glasfaser-verfugbar") : 0;
                            available = rates[rateid]?.available ? "true" : "false";
                        } else if(rates[rateid]?.available) {
                            yetToOpenLayer ? openLayer("exakt-verfugbar") : 0;
                            available = "true";
                        } else {
                            for(let rate in rates) {
                                if(rate !== rateid) {
                                    let ratedata = rates[rate];
                                    if(ratedata.available && ratedata.category === area) {
                                        found = true;
                                        break;
                                    }
                                }
                            }
                            found && yetToOpenLayer ? openLayer("andere-verfugbar") : 0;      // Note: "no orderable = available rates found" not handled
                            available = "false";
                        }
                        $("#detailAvailableBubble").css({"display": available === "true" ? "table" : "none"});
                    } else {
                        let area = document.body.classList.contains("b2b") ? "b2b" : "b2c";
                        available = "false";
                        for(let rate in rates) {
                            let ratedata = rates[rate];
                            if(ratedata.available && ratedata.category === area) {
                                available = "true";
                                break;
                            }
                        }
                    }

                    switch(available) {
                        case "true":
                            $("body").addClass("availability-given");
                            break;
                        case "false":
                            $("body").addClass("availability-not-given");
                            break;
                        default:
                    }


                    var recheck = +sessionStorage.getItem("recheck");
                    if(!isNaN(recheck)) {
                        if(recheck !== 0) {     // recheck === 0 is keep forever
                            recheck -= new Date().getTime();
                            if (recheck > 0) {
                                clearTimeout(clearSessionTimeout);
                                clearSessionTimeout = setTimeout(clearSession, recheck);
                            } else {
                                clearSession();
                                return;
                            }
                        }
                    }

                    $("body").addClass("availability-check-performed").removeClass("availability-check-not-performed");

                    recommend();
                } else {
                    $("body").addClass("availability-check-not-performed").removeClass("availability-check-performed");
                    // Cookies are still present.
                    // We better not delete them because then they would be missing in the tab where the sessionStorage is still valid.
                    // Cookies are valid across all tabs, sessionStorage is only valid for the current tab.
                }
            } else {
                if(sessionStorage.getItem("availabilitychecked") !== "true") {
                    $("body").addClass("availability-check-not-performed").removeClass("availability-check-performed");
                } else {
                    clearSession(true);
                    location.reload();
                }
            }
        }
        actOnAvailabilityPresent();


        function storeIndex() {
            sessionStorage.setItem("rateIndex", $(this).closest(".rate").data("index"));
        }
        $(".js-order-link").on("click", storeIndex);


        /**
         *  set recommended rate
         */
        var alreadyScrolled = false;

        var isCampaign = false;

        function recommend() {
            $("[recommended]").removeAttr("recommended");
            if(isCampaign) {
                return;
            }
            var $recommendable = $("body.availability-given .rate.js-presentable.js-rate-availability-given");
            if($recommendable.length) {
                var recommend = $recommendable[$recommendable.length - 1];
                // https://viazenetti.atlassian.net/browse/LEOSERVICE-704
                // var recommendPreLast = $recommendable[$recommendable.length - 2];
                // if(parseFloat(recommend.dataset.downstream) > 100 && $recommendable.length > 1 && getComputedStyle(recommendPreLast).display !== "none") {
                //    recommend = recommendPreLast;
                // }
                if(getComputedStyle(recommend).display !== "none") {
                    recommend.setAttribute("recommended", "");

                    // scroll recommended rate into view
                    if(location.hash.indexOf("#tarif-") !== 0) {
                        // LEOSERVICE-829: only scroll to recommended rate
                        /*var $notAvailable = $(".rate.rate-availability-not-given");
                        if($notAvailable.length) {
                            $notAvailable = $notAvailable.first();
                            var oc = $notAvailable.closest(".overflow-container");
                            if(oc.length) {
                                var visibleWidth = oc.width();
                                var firstNotAvailableLeft = $notAvailable.position().left;
                                var firstNotAvailableWidth = firstNotAvailableLeft / $notAvailable.index();
                                var visibleAmountBeforeFirstNotAvailable = visibleWidth / firstNotAvailableWidth;
                                visibleAmountBeforeFirstNotAvailable = Math.max(1, Math.floor(visibleAmountBeforeFirstNotAvailable));
                                oc[0].scrollLeft = firstNotAvailableLeft - visibleAmountBeforeFirstNotAvailable * firstNotAvailableWidth;
                            }
                        } else {*/
                            var $recommend = $(recommend);
                            var oc = $recommend.closest(".overflow-container");
                            if(oc.length) {
                                var recommendedIndex;
                                var rateCount = 0;
                                $(".rate").each(function() {
                                    if(getComputedStyle(this).display !== "none") {
                                        if(this === recommend) {
                                            recommendedIndex = rateCount;
                                        }
                                        ++rateCount;
                                    }
                                });
                                oc[0].scrollLeft = recommendedIndex * (oc[0].scrollWidth / rateCount);
                            }
                        /*}*/
                        return true;
                    }
                }
            }
            return false;
        }
        alreadyScrolled = alreadyScrolled || recommend();


        /**
         *  set promotion layer content
         */
        window.promotion = function (rate) {
            var $promoted = $(typeof rate !== "undefined" ? rate : '[data-haspromotion]:not([data-haspromotion=""])');
            if($promoted.length) {
                var $eyecatcher = $promoted.find("[data-longtext]");
                $eyecatcher.off("mouseenter touchstart mouseleave").on("mouseenter touchstart", showPromotionLayer).on("mouseleave", function() {
                    hide($("#Promotion"));
                });

                // scroll promoted rate into view
                if(!alreadyScrolled) {
                    var $promotedFTTH = $promoted.filter('[data-type="ftth"]');
                    if($promotedFTTH.length) {
                        $promoted = $promotedFTTH.eq(0);
                    } else {
                        $promoted = $promoted.eq(0);
                    }
                    var promoted = $promoted[0];
                    if(location.hash.indexOf("#tarif-") !== 0 && $promoted.hasClass("js-rate-availability-given") && getComputedStyle(promoted).display !== "none") {
                        var promotedIndex;
                        var rateCount = 0;
                        $(".rate").each(function() {
                            if(getComputedStyle(this).display !== "none") {
                                if(this === promoted) {
                                    promotedIndex = rateCount;
                                }
                                ++rateCount;
                            }
                        });
                        var oc = $promoted.closest(".overflow-container");
                        oc.length > 0 ? (oc[0].scrollLeft = promotedIndex * (oc[0].scrollWidth / rateCount)) : 0;
                        return true;
                    }
                }
            }
            return false;
        };
        alreadyScrolled = promotion() || alreadyScrolled;       // promotion sets event handlers and itself checks for alreadyScrolled


        /**
         *  scroll to Top Seller
         */
        function topSeller() {
            var topsellerIndex = -1;
            var rateCount = 0;
            $(".rate").each(function() {
                if(getComputedStyle(this).display !== "none") {
                    if(this.hasAttribute("is-topseller")) {
                        topsellerIndex = rateCount;
                    }
                    ++rateCount;
                }
            });
            if(topsellerIndex !== -1) {
                var oc = $("[is-topseller]").closest(".overflow-container");
                oc.length > 0 ? (oc[0].scrollLeft = topsellerIndex * (oc[0].scrollWidth / rateCount)) : 0;
                return true;
            } else {
                var ftthIndex = -1;
                var rateCount = 0;
                $(".rate").each(function() {
                    if(getComputedStyle(this).display !== "none") {
                        if(this.dataset.type === "ftth") {
                            ftthIndex = rateCount;
                        }
                        ++rateCount;
                    }
                });
                if(ftthIndex !== -1) {
                    var oc = $('[data-type="ftth"]').closest(".overflow-container");
                    oc.length > 0 ? (oc[0].scrollLeft = ftthIndex * (oc[0].scrollWidth / rateCount)) : 0;
                    return true;
                }
            }
        }
        alreadyScrolled = alreadyScrolled || topSeller();


        /**
         *  slider
         */
        var slides = [];
        $(".js-slider").each(function(i) {
            var $this = $(this);
            $this.data("index", slides.length);
            var navdots = $this.nextAll(".slider-nav-dots");
            var anzahlen = $this.next(".js-slider-anzahl");
            var anzahl = anzahlen.data("anzahl");
            var anzahlDesktopMax = anzahlen.data("anzahldesktopmax");
            var anzahlMobileMax = anzahlen.data("anzahlmobilemax");
            slides.push(tns({
                container: this,
                controls: false,
                responsive: {
                    1: {
                        items: !isNaN(anzahlMobileMax) && anzahl <= anzahlMobileMax ? anzahl : anzahlMobileMax,
                        nav: anzahl > anzahlMobileMax,
                        navContainer: navdots[0]
                    },
                    992: {
                        items: !isNaN(anzahlDesktopMax) && anzahl <= anzahlDesktopMax ? anzahl : anzahlDesktopMax,
                        nav: anzahl > anzahlDesktopMax,
                        navContainer: navdots[0]
                    }
                }
            }));
            slides[slides.length - 1].events.on("indexChanged", function(e) {
                navdots.find(".active").removeClass("active");
                navdots.children().eq(e.displayIndex - 1).addClass("active");
            });
            navdots.children().first().addClass("active");
        });
        function gotoSlide() {
            var $this = $(this);
            slides[$this.closest(".slider-nav-dots").prevAll(".tns-outer").find(".js-slider").data("index")].goTo($this.index());
        }
        $(".nav-dot").on("click", gotoSlide);


        /**
         *  rates-overview scroll
         */
         function checkNav($overview, overflowContainer) {
            $overview.removeClass("nav-no-right nav-no-left");
            var atend = false;
            if(overflowContainer.scrollLeft + overflowContainer.clientWidth >= overflowContainer.scrollWidth) {
                $overview.addClass("nav-no-right");
                atend = true;
            }
            if(overflowContainer.scrollLeft === 0) {
                $overview.addClass("nav-no-left");
                atend = true;
            }
            return atend;
        }

        var lastRatesView = {};
        function determineRatesNav() {
            $(".rates-container").each(function() {
                var $this = $(this);
                var $overview = $this.closest(".tarif-bersicht");
                var overflowContainer = $this.closest(".overflow-container")[0];
                if($this.width() > $overview.width()) {
                    $overview.addClass("nav-active");
                    var rateCount = 0;
                    $this.find(".rate").each(function() {
                        if(getComputedStyle(this).display !== "none") {
                            ++rateCount;
                        }
                    });
                    var rateWidth = $this.width() / rateCount;
                    if(typeof this.dataset.viewid === "undefined") {
                        this.dataset.viewid = (Math.random() + "").substring(2);
                        lastRatesView[this.dataset.viewid] = overflowContainer.scrollLeft / rateWidth;
                    } else {
                        overflowContainer.scrollLeft = lastRatesView[this.dataset.viewid] * rateWidth;
                    }
                } else {
                    $overview.removeClass("nav-active");
                }
                checkNav($overview, overflowContainer);
            });
        }
        $(window).on("resize", determineRatesNav);
        determineRatesNav();
        var dragEnabled = false;
        function enableDrag() {
            dragEnabled = true;
        }
        function disableDrag() {
            dragEnabled = false;
        }
        function dragIfEnabled(e) {
            if(dragEnabled) {
                this.scrollLeft -= e.originalEvent.movementX;
            }
        }
        var lastTouchX = 0;
        var lastTouchY = 0;
        var touchDragEnabled = false;
        function enableTouchDrag(e) {
            touchDragEnabled = true;
            lastTouchX = e.originalEvent.touches[0].screenX;
            lastTouchY = e.originalEvent.touches[0].pageY;
        }
        function disableTouchDrag() {
            touchDragEnabled = false;
        }
        function touchDragIfEnabled(e) {
            if(touchDragEnabled) {
                this.scrollLeft -= e.originalEvent.touches[0].screenX - lastTouchX;
                lastTouchX = e.originalEvent.touches[0].screenX;
                if (Math.abs(e.originalEvent.touches[0].pageY - lastTouchY) < 6) {
                    e.preventDefault();
                }
                lastTouchY = e.originalEvent.touches[0].pageY;
            }
        }
        var dataTouchStart = {};
        function recordTime(e) {
            dataTouchStart.time = performance.now();
            dataTouchStart.x = this.scrollLeft;
            enableTouchDrag(e);
        }
        function snapScroll() {
            disableTouchDrag();
            var deltaTOriginal = performance.now() - dataTouchStart.time;
            var v = (this.scrollLeft - dataTouchStart.x) / deltaTOriginal;
            var T = deltaTOriginal;     //1000;       // ms  =  time to take to linearly reduce v to 0
            var deltaX = 1/2 * v * T;
            var endX = this.scrollLeft + deltaX;
            var $this = $(this);
            var rateCount = 0;
            $this.find(".rate").each(function() {
                if(getComputedStyle(this).display !== "none") {
                    ++rateCount;
                }
            });
            var rateWidth = ($this.find(".rates-container").width() / rateCount);
            var destRate = endX / rateWidth;
            var destRateVisiblePart = 1 - (destRate - ~~destRate);
            var viewRemainderWidth = $this.width() / rateWidth - destRateVisiblePart;
            destRate = ~~destRate;
            if(destRateVisiblePart < .5) {//viewRemainderWidth > destRateVisiblePart) {     // only use rate partially visible to determine whether to show it or not
                destRate++;
            }
            var targetEndX = destRate * rateWidth;
            var targetDeltaX = targetEndX - this.scrollLeft;
            var a = 2 * (targetDeltaX - v * T) / (T * T);
            var startX = this.scrollLeft;
            var startTime = performance.now();
            var scrollView = this;
            function snap(t) {
                var deltaT = t - startTime;
                if(deltaT >= T) {
                    scrollView.scrollLeft = targetEndX;
                } else {
                    scrollView.scrollLeft = startX + 1/2 * a * deltaT * deltaT + v * deltaT;
                    requestAnimationFrame(snap);
                }
            }
            requestAnimationFrame(snap);
        }
        $(".rates-container").each(function() {
            var $this = $(this);
            var overflowContainer = $this.closest(".overflow-container").on("scroll", storePositionAndCheckNav).on("touchstart", recordTime).on("touchmove", touchDragIfEnabled).on("touchend", snapScroll).on("mousedown", enableDrag).on("mouseup", disableDrag).on("mousemove", dragIfEnabled)[0];
            function storePositionAndCheckNav() {
                var t = $this[0];
                if(typeof t.dataset.viewid === "undefined") {
                    t.dataset.viewid = (Math.random() + "").substring(2);
                }
                var rateCount = 0;
                $this.find(".rate").each(function() {
                    if(getComputedStyle(this).display !== "none") {
                        ++rateCount;
                    }
                });
                lastRatesView[t.dataset.viewid] = overflowContainer.scrollLeft / ($this.width() / rateCount);
                checkNav($this.closest(".tarif-bersicht"), overflowContainer);
            }
        });

        
        $(".rates-container").each(function() {
            var $this = $(this);
            var overflowContainer = $this.closest(".overflow-container")[0];
            var $overview = $this.closest(".tarif-bersicht");
            var scrollTimeout;
            var scrollAnimationRequest = 0;
            function doScroll(scrollDir) {
                function setScroll() {
                    overflowContainer.scrollLeft += scrollDir * 6;
                    if(!checkNav($overview, overflowContainer)) {
                        scrollAnimationRequest = requestAnimationFrame(setScroll);
                    }
                }
                scrollTimeout = setTimeout(setScroll, 400);
            }
            function releaseScroll() {
                cancelAnimationFrame(scrollAnimationRequest);
                clearTimeout(scrollTimeout);
            }
            function slideLeft() {
                scrollAnimationRequest = 0;
                doScroll(1);
            }
            function slideRight() {
                scrollAnimationRequest = 0;
                doScroll(-1);
            }
            function doShift(dir) {
                var rateCount = 0;
                $this.find(".rate").each(function() {
                    if(getComputedStyle(this).display !== "none") {
                        ++rateCount;
                    }
                });
                var rateWidth = $this.width() / rateCount;
                var firstVisibleRate = Math.floor(overflowContainer.scrollLeft / rateWidth);
                var lastRateWhoseRightLimitIsLeftTheRightViewportBorder = Math.floor((overflowContainer.scrollLeft + overflowContainer.clientWidth) / rateWidth) - 1;
                var firstFullyVisibleRate = Math.ceil(overflowContainer.scrollLeft / rateWidth);
                if(lastRateWhoseRightLimitIsLeftTheRightViewportBorder < firstVisibleRate) {
                    lastRateWhoseRightLimitIsLeftTheRightViewportBorder++;
                }
                var targetLeft = rateWidth * ((Math.sign(dir) > 0 ? /*lastRateWhoseRightLimitIsLeftTheRightViewportBorder*/ firstFullyVisibleRate : firstFullyVisibleRate) + dir);
                var startLeft = overflowContainer.scrollLeft;
                var tStart = performance.now();
                var T = 400;
                function animateScroll(t) {
                    var deltaT = t - tStart;
                    if(deltaT >= T) {
                        overflowContainer.scrollLeft = targetLeft;
                        checkNav($overview, overflowContainer);
                    } else {
                        overflowContainer.scrollLeft = startLeft + (targetLeft - startLeft) * Math.sin(deltaT / T * Math.PI / 2);
                        requestAnimationFrame(animateScroll);
                    }
                }
                requestAnimationFrame(animateScroll);
            }
            function shiftLeft() {
                scrollAnimationRequest < 1 ? doShift(1) : 0;
            }
            function shiftRight() {
                scrollAnimationRequest < 1 ? doShift(-1) : 0;
            }
            $overview.find(".nav-next").on("mousedown", slideLeft).on("mouseup", releaseScroll).on("click", shiftLeft);
            $overview.find(".nav-prev").on("mousedown", slideRight).on("mouseup", releaseScroll).on("click", shiftRight);
            checkNav($overview, overflowContainer);
        });


        /**
         *  Dropdown selection general
         */
        function openDropdown(e) {
            show($(this).closest(".js-dropdown-items").find(".js-dropdown-items-container"));
            e.stopPropagation();
        }
        function closeDropdown(e) {
            if($(e.relatedTarget).closest(".js-dropdown-items-container").length < 1) {           // if we don't click the dropdown items container (content), treat it as blur
                hide($(this).closest(".js-dropdown-items").find(".js-dropdown-items-container"));
            }
        }
        $(".js-dropdown-display").on("click", openDropdown).on("blur", closeDropdown);
        function selectDropdownItem() {
            var $dropdown = $(this).closest(".js-dropdown-items");
            
            $dropdown.find(".js-dropdown-display").html(this.innerHTML);
            $dropdown.attr("value", this.dataset.val);
        
            if (this.hasAttribute("href")) {
                $dropdown.trigger("pickedup", [this.getAttribute("href").substring(1)]);
            } else {
                $dropdown.trigger("pickedup", [this.dataset.val.replace("&#39;", "'")]);
            }
            hide($dropdown.find(".js-dropdown-items-container"));
        }
        $(".js-dropdown-item").on("click", selectDropdownItem);
        $(".js-dropdown-item.js-preselected").click();
        
        function keyNavigationCore(e) {
            var $this = $(this);
            var $focused = $this.find(":focus");
            var dir = e.which - 39;     // down = 40 = next, up = 38 = previous
            if(dir * dir !== 1) {
                if(e.which === 13 || e.which === 9 && !e.shiftKey) {    // enter, tab
                    $focused.length ? $focused[0].click() : 0;                    // use JS because jQ only dispatches the event but doesn't do the default click action (eg execute a href when focused is an "a")
                    e.stopPropagation();
                    e.preventDefault();
                }/*
                if(e.which === 27) {

                }*/
                return;
            }
            var $children = $this.children();
            if($focused.length < 1) {
                var newFocusedIndex = $this.closest(".verfuegbarkeits-inputs").length ? 1 : 0;
                show($this);
            } else {
                var newFocusedIndex = ($focused.index() + $children.length + dir) % $children.length;
            }
            $children.eq(newFocusedIndex).focus();
            e.stopPropagation();
            e.preventDefault();
        }
        function keyNavigation(e) {
            keyNavigationCore.call($(this).nextAll(".js-dropdown-items-container"), e);
        }
        $(".js-dropdown-display, .verfuegbarkeits-inputs input").on("keydown", keyNavigation);
        $(".js-dropdown-items-container").on("keydown", keyNavigationCore);


        /**
         *  Ausbaugebiete Filter
         */
        function filterAusbaugebiete(e, d) {
            if(document.title.indexOf('" |') > -1) {
                document.title = document.title.replace(/\"[^\"]*\"\ \|/, '"' + d + '" |');
            } else {
                document.title = document.title.replace("|", '"' + d + '" |');
            }
        }
        var $ausbauFilter = $("#ausbaugebieteFilter").on("pickedup", filterAusbaugebiete);
        if($ausbauFilter.length) {
            function selectAusbaugebiete(event) {
                if(location.href.indexOf("#") > -1) {
                    var d = location.hash.substring(1);
                    if(['', 'vorvermarktung', 'planungsphase', 'bauphase', 'netz-aktiv'].indexOf(d) > -1) {
                        if(d !== '') {
                            $(".ausbauphasen-anzeige").hide();
                            $(".ausbauphase-" + d).show();
                        } else {
                            $(".ausbauphasen-anzeige").show();
                        }
                        typeof gtag === "function" && gtag("event", "page_view", {"page_title": document.title});
                        $ausbauFilter.find('.js-dropdown-item[href="#' + d + '"]').click();
                        if(['', 'vorvermarktung', 'planungsphase', 'bauphase', 'netz-aktiv'].includes(event ? event.originalEvent.oldURL.substring(event.originalEvent.oldURL.indexOf('#') + 1) : '-1')) {
                            scrollTo({
                                top: $ausbauFilter.offset().top - 200,
                                left: 0,
                                behavior: d !== '' ? 'smooth' : 'instant'
                            });
                        }
                    } else {
                        $(".ausbauphasen-anzeige").show();
                    }
                }
            }
            $(window).on("hashchange", selectAusbaugebiete);
            selectAusbaugebiete();
        }


        /**
         *  Ausbaugebiete Suche
         */
        var $ausbaugebietenameSuchwort = $("#ausbaugebietenameSuchwort");
        var $ausbaugebietenameFilterDDC = $("#ausbaugebietenameFilter .js-dropdown-items-container");
        var $ausbaugebietenameSuche = $('#ausbaugebietenameSucheContainer input[name="fulltextsearch"]').on("input", function() {
            $ausbaugebietenameSuche.attr("data-val", this.value);
            $ausbaugebietenameSuchwort.text('#ausbaugebietenameFilter .dropdown-item:not([data-find*="' + this.value + '"i]){display:none}');
            show($ausbaugebietenameFilterDDC);
        });


        /**
         *  Ausbaugebiete Animationen
         */
        var animatables = document.querySelectorAll('.js-animparent');
        var animatingNumbers = {};
        function animateAnimatables() {
            Array.prototype.forEach.call(animatables, function(animatable) {
                var e = animatable.querySelector('[data-anim]');
                var rect = e.getBoundingClientRect();
                if(rect.y > 0  && rect.y + e.clientHeight < innerHeight) {
                    e.setAttribute("data-anim", "running");
                    var countto = animatable.querySelector("[data-countto]");
                    if(countto !== null) {
                        var animid = countto.getAttribute("data-animid");
                        if(animid === null) {
                            animid = "i" + (Math.random() + "").substring(2);
                            countto.setAttribute("data-animid", animid);
                            animatingNumbers[animid] = false;
                        }
                        function startCounting(startTime) {
                            animatingNumbers[animid] = true;
                            var targetValue = parseFloat(countto.dataset.countto);
                            function countNumber(currentTime) {
                                if(animatingNumbers[animid] === true) {
                                    countto.textContent = ~~((currentTime - startTime) / 250) * 5;
                                    if(parseFloat(countto.textContent) < targetValue) {
                                        requestAnimationFrame(countNumber);
                                    } else {
                                        countto.textContent = countto.dataset.countto;                              // requestAnimationFrame pauses when the tab is hidden, here make sure the end value is set
                                    }
                                } else {
                                    countto.textContent = 0;
                                }
                            }
                            requestAnimationFrame(countNumber);
                        }
                        if(animatingNumbers[animid] === false) {
                            requestAnimationFrame(startCounting);
                        }
                    }
                } else {
                    e.setAttribute("data-anim", "prestart");
                    for(var i in animatingNumbers) {
                        animatingNumbers[i] = false;
                    }
                }
            })
        }
        if(animatables.length) {
            addEventListener("scroll", animateAnimatables);
            animateAnimatables();
        }


        /**
         * generic input handling
         */
        function clearInput() {
            $(this).closest(".input-container").find("input").first().val("").trigger("input");
        }
        $(".js-clear-input").on("click", clearInput);

        function markInput() {
            this.setAttribute("data-val", this.value);
        }
        $(".js-generic-input").on("input", markInput);


        /**
         * filter like in pressreleases and blog
         */
        $(".js-filterlabel").on("click", function() {
            $(this).parent().toggleClass("visible");
        });
        $('.filterrow .js-dropdown-item[href="' + decodeURIComponent(location.hash).split("/")[0] + '"]').click();


        /**
         * Job link to application
         */
        var $ja = $(".job-application a");
        if($ja.length) {
            $ja.attr("href", $ja.attr("href").replace("BITTE_NICHT_AUSFUELLEN", $(".job_description h1").text().replace(" ", "+")));
        }


        /**
         * Tarifübersicht-Navipfeile Animation
         */
        var ratesOverview = document.querySelector('.tarif-bersicht');
        var ratesNavs = document.querySelectorAll('.tarif-bersicht > .nav');
        function positionRatesNav() {
            Array.prototype.forEach.call(ratesNavs, function(ratesNav) {
                var rectNav = ratesNav.getBoundingClientRect();
                var rectOverview = ratesOverview.getBoundingClientRect();
                var navReferenceTop = 0;
                if(rectOverview.y < 0) {
                    navReferenceTop = -rectOverview.y;
                }
                var navReferenceBottom = rectOverview.height - rectNav.height;
                if(rectOverview.y + rectOverview.height > innerHeight) {
                    navReferenceBottom = innerHeight - rectOverview.y - rectNav.height;
                }
                var topValue = (navReferenceTop + navReferenceBottom) / 2;
                if(topValue < 330) {
                    topValue = 330;
                }
                ratesNav.style.top = topValue + "px";
            });
        }

        /**
         * Tarifübersicht-Tariflabels sticky
         */
        var $rate = $(".rate");
        var $rateName = $(".rate-name");
        var $header = $("header");
        var lastSticked = false;
        function stickyLabels () {
            $rate.find(".rate-content-container").css({marginTop:(0)+"px"});
            $rate.find(".rate-content").css({marginTop:(10)+"px"});
            if(innerWidth > 991 && $rate.find(".rate-content-container").length > 0) {
                var refRate;
                $rate.each(function() {
                    var computedDisplay = getComputedStyle(this).display;
                    if(computedDisplay !== "none" && computedDisplay !== "") {          // rates removed (like in order process) have empty display
                        refRate = this;
                        return false;
                    }
                });
                var y = refRate.getBoundingClientRect().y - (document.body.classList.contains("fixed-header") && $header.length ? ($header.height() + $header[0].getBoundingClientRect().y + 105) : 90);
                var $ref= $(refRate);
                if(y < 0) {
                    $rateName.css({"transform": "translateY(" + -y + "px)"});
                    if(!lastSticked) {
                        lastSticked = true;
                        $rateName.addClass("sticked");
                    }
                    var box = refRate.querySelector(".rate-name").getBoundingClientRect();
                    var $ref= $(refRate);
                    $ref.find(".rate-content-container").css({marginTop:(0)+"px"});
                    var diff = $ref.find(".rate-content-container").get(0).getBoundingClientRect().y - (box.y + box.height);
                    if(diff < 10 && -diff < $ref.closest(".rates-container").get(0).getBoundingClientRect().height) {
                        $rate.find(".rate-content").css({marginTop:(10+diff)+"px"});
                        $rate.find(".rate-content-container").css({marginTop:(-diff)+"px"});
                    }
                } else {
                    $rateName.css({"transform": "translateY(0px)"});
                    if(lastSticked) {
                        lastSticked = false;
                        $rateName.removeClass("sticked");
                    }
                }
            } else {
                $rateName.css({"transform": "translateY(0px)"});
                if(lastSticked) {
                    lastSticked = false;
                    $rateName.removeClass("sticked");
                }
            }
        }

        if(ratesOverview !== null) {
            addEventListener("scroll", positionRatesNav);
            addEventListener("resize", positionRatesNav);
            positionRatesNav();
            addEventListener("scroll", stickyLabels);
            addEventListener("resize", stickyLabels);
            stickyLabels();
        }


        /**
         * Newsticker Animation
         */
        $marquee = $('.newsticker-text').marquee({ 
            startVisible: true,           
            duration: 20000,
            gap: 70
        });  
        $marquee.hover(function(){ $marquee.marquee('pause'); }, function(){ $marquee.marquee('resume'); })

        
        /**
         * Copy URL
         */
        var copyURL = document.getElementById('copyURL');
        if(copyURL !== null) {
            copyURL.addEventListener('click', function(){
                var copylink = document.createElement('input'),
                text = window.location.href;
            
                document.body.appendChild(copylink);
                copylink.value = text;
                copylink.select();
                document.execCommand('copy');
                document.body.removeChild(copylink);
            });


            $("#copyURL").click(function () {
                $('.share').append("<div class='text-s alertText'>Link wurde in die Zwischenablage kopiert</div>");
                setTimeout(function() {
                    $( ".alertText" ).remove();
                }, 1500);

                
                $('.share').append("<div class='text-s share-copy-active'><img src='/wp-content/themes/amplus/assets/images/leonet_ico_share_copy_ready.svg'>Kopiert</div>");
                setTimeout(function() {
                    $( ".share-copy-active" ).remove();
                }, 1500);
            });
        }


        /**
         * read-moreable
         */
        var readMoreableContent = {};
        function showMoreReadableContent() {
            var $rIdKeeper = $(this).closest(".read-moreable");
            if($rIdKeeper.hasClass("morereadable-shown")) {
                $rIdKeeper.html(readMoreableContent[$rIdKeeper.attr("id")][1]);
                $rIdKeeper.removeClass("morereadable-shown");
                $rIdKeeper.find(".read-more-separator").on("click", showMoreReadableContent);
            } else {
                $rIdKeeper.addClass("morereadable-shown");
                $rIdKeeper.html(readMoreableContent[$rIdKeeper.attr("id")][0]);
                $rIdKeeper.find(".read-less-clicker").on("click", showMoreReadableContent);
            }
        }
        $(".read-moreable").each(function() {
            var $this = $(this);
            if($this.html().indexOf("++:") > -1) {
                var newHTML = $this.html().replace("++:", "<span class='read-more-separator'></span>") + "<span class='read-less-clicker'></span>";
                $this.html(newHTML);
                var rId = "r" + ("" + Math.random()).substring(2);
                readMoreableContent[rId] = [newHTML];
                $this.attr("id", rId);
                $sep = $this.find(".read-more-separator");
                var lastNode = $sep[0];
                var parent = lastNode.parentElement;
                do {
                    while(parent.lastChild !== lastNode) {
                        parent.removeChild(parent.lastChild);
                    }
                    if(parent === this) {
                        break;
                    }
                    lastNode = parent;
                    parent = lastNode.parentElement;
                } while(true);
                readMoreableContent[rId].push($this.html());
                $sep.on("click", showMoreReadableContent);
            }
            $this.addClass("readable");
        });


        /**
         * Leoxikon-Specials
         */
        $(".leoxicon-special").appendTo("#specialcontentSpace");


        /**
         * zoom support
         */
        function toggleZoom () {
            $(this).toggleClass("zoomed");
        }
        $(".zoom-available").parent().on("click", toggleZoom);


        /**
         * duedate countdown
         */
        function countdownDuedate(e) {
            var duedate = e.dataset.duedate.split(".");
            if(duedate.length === 3) {
                var days = e.querySelector(".js-duedate-days");
                var hours = e.querySelector(".js-duedate-hours");
                var minutes = e.querySelector(".js-duedate-minutes");
                var seconds = e.querySelector(".js-duedate-seconds");
                var dateDue = new Date();
                dateDue.setFullYear(+duedate[2] + (duedate[2].length === 4 ? 0 : 2000));
                dateDue.setMonth(parseInt(duedate[1], 10) - 1);
                dateDue.setDate(parseInt(duedate[0], 10));
                dateDue.setHours(0);
                dateDue.setMinutes(0);
                dateDue.setSeconds(0);
                dateDue.setMilliseconds(0);
                var datetimeDue = dateDue.getTime() + 24 * 60 * 60 * 1000;      // due date is at the end of the day
                
                var dueDateCounterInterval;

                function setTime() {
                    var datetimeNow = Date.now();
                    var timeRemaining = (datetimeDue - datetimeNow) / 1000;
                    if(timeRemaining > 0) {
                        seconds.innerText = (~~(timeRemaining % 60)).toLocaleString("de-DE", { minimumIntegerDigits: 2 });
                        timeRemaining = ~~(timeRemaining / 60);
                        minutes.innerText = (~~(timeRemaining % 60)).toLocaleString("de-DE", { minimumIntegerDigits: 2 });
                        timeRemaining = ~~(timeRemaining / 60);
                        hours.innerText = (~~(timeRemaining % 24)).toLocaleString("de-DE", { minimumIntegerDigits: 2 });
                        timeRemaining = ~~(timeRemaining / 24);
                        days.innerText = timeRemaining.toLocaleString("de-DE", { minimumIntegerDigits: 2 });
                    } else {
                        clearInterval(dueDateCounterInterval);
                        seconds.innerText = "00";
                        minutes.innerText = "00";
                        hours.innerText = "00";
                        days.innerText = "00";
                        var $container = $(e).closest(".duedate-countdown-container");
                        if($container.get(0).dataset.duehide === "true") {
                            $container.hide();
                        } else {
                            $container.find(".duedate-done").show();
                        }
                    }
                }
                if(Date.now() < datetimeDue - (((parseFloat(e.dataset.duedatefrom) + 1) * 24 * 60 * 60 * 1000) || datetimeDue)) {
                    e.classList.add("no-countdown");
                } else {
                    var timeRemaining = datetimeDue - Date.now();
                    if(timeRemaining > 0) {
                        dueDateCounterInterval = setInterval(setTime, 1000);
                    } else {
                        seconds.innerText = "00";
                        minutes.innerText = "00";
                        hours.innerText = "00";
                        days.innerText = "00";
                        var $container = $(e).closest(".duedate-countdown-container");
                        if($container.get(0).dataset.duehide === "true") {
                            $container.hide();
                        } else {
                            $container.find(".duedate-done").show();
                        }
                    }
                    $(".ausbauphasen-detail-footer").hide();
                }
            }
        }
        $(".js-duedate-countdown").each(function() {
            countdownDuedate(this);
        });


        /**
         *  general Escape helper
         */

        $("body").on("keydown", e => {
            if(e.key === "Escape") {
                hide($(".js-dropdown-items-container"));
            }
        }).on("click", () => {
            hide($(".js-dropdown-items-container"));
        });


        /**
         *  Form field highlight helper
         */

        $('.input-container:has(label) input[data-val=""]').each(function() {
            var input = this;
            setTimeout(function() {
                $(input).attr("data-val", input.value);
            }, 300);
        });


        /**
         *  Gravity Forms label look helper
         */

        function updateGravityFieldState() {
            $(this).closest(".gfield").attr("data-input", this.value);
        }
        $("body:has(form.plain-form .gfield)").on("input", ".gfield input, .gfield select, .gfield textarea", updateGravityFieldState);

        $(document).on('gform_post_render', function() {
            $(".gform-body .read-only").find("input, select, textarea").attr("readonly", "readonly");
        });


        /**
         *  Partnershops Shop Deeplink: close search field
         */

        var storeLocator = document.getElementById("asl-storelocator");
        if(storeLocator && location.hash.length > 1) {
            window.asl_event_hook = function (_event) {
                if(_event.type === "load") {
                    $(".close-directions.sl-close").trigger("click");
                }
            };
            $(".close-directions.sl-close").trigger("click");
            scrollTo({
                left: 0,
                top: document.documentElement.scrollTop + storeLocator.previousElementSibling?.previousElementSibling?.getBoundingClientRect().y - 150,
                behavior: "smooth"
            });
        }


        /**
         * LEOXIKON Post-Vorschau 
         * Flyout für Internetseite mit Kurzinfo 
         * Kann auf der gesamten Website integriert werden 
         * Beischpiel-link: #post-38595, #post-[leoxikon_post_id]
         */

        var leoxikonPostPreview = $('<div class="leoxikon-post-preview"></div>').appendTo('body');
        var leoxikonPostPreviewVisible = false;
        var currentLink;

        $('a[href^="#post-"]').hover(function(e) {
            currentLink = $(this);
            var postID = currentLink.attr('href').replace('#post-', '');

            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: { action: 'leoxikon_preview', post_id: postID },
                success: function(response) {
                    leoxikonPostPreview.html(response);
                    var offset = currentLink.offset();
                    var height = currentLink.outerHeight();
                    var windowWidth = $(window).width();

                    if (windowWidth <= 768) {
                        leoxikonPostPreview.css({
                            top: offset.top + height + 5,
                            left: (windowWidth - leoxikonPostPreview.outerWidth()) / 2
                        });
                    } else {
                        leoxikonPostPreview.css({
                            top: offset.top + height + 5,
                            left: offset.left
                        });
                    }

                    leoxikonPostPreview.show();
                    leoxikonPostPreviewVisible = true;
                }
            });
        });

        $(document).on('click', function(e) {
            if (!$(e.target).closest('.leoxikon-post-preview').length && !$(e.target).is('a[href^="#post-"]')) {
                leoxikonPostPreview.hide();
                leoxikonPostPreviewVisible = false;
            }
        });

        $(document).on('click', '.close-leoxikon-post-preview', function() {
            leoxikonPostPreview.hide();
            leoxikonPostPreviewVisible = false;
        });

        $(document).on('click', 'a[href^="#post-"]', function(e) {
            e.preventDefault();
        });


        /**
         * Dynamische Anpassung von negativen Top-Margin-Werten
            Die Klasse „margin-adjust-negative-wert“ wird verwendet, um negative margin-top Wert für ein Element zu definieren.
            Der Teil (wert) steht für eine Zahl, die den Betrag der negativen Margin angibt.
            Zum Beispiel bedeutet „margin-adjust-negative-100„, dass die negative margin-top -100px beträgt.
            Für mobile Geräte wird der Abstand halbiert, d.h. die negative margin-top beträgt dann -50px.
         */
        $('[class*="margin-adjust-negative-"]').each(function() {
            var className = $(this).attr('class');
            var match = className.match(/margin-adjust-negative-(\d+)/);

            if (match) {
                var value = parseInt(match[1]);
                $(this).css({
                    '--margin-top': `-${value}px`
                });
            }
        });


        /**
         * Kontakt Servicemenü 
         */
        $('.kontakt-b2c .toggle-beratung').on('click', function () {
            $('#Kontakt').addClass('show-b2c').removeClass('show-b2b').addClass('show-beratung');
        });

        $('.kontakt-b2c .link-privat-beratung').on('click', function () {
            $('#Kontakt').addClass('show-b2b').removeClass('show-b2c').removeClass('show-beratung');
        });

        $('.kontakt-b2b .toggle-beratung').on('click', function () {
            $('#Kontakt').addClass('show-b2b').removeClass('show-b2c').addClass('show-beratung');
        });

        $('.kontakt-b2b .link-geschaeft-beratung').on('click', function () {
            $('#Kontakt').addClass('show-b2c').removeClass('show-b2b').removeClass('show-beratung');
        });

        $('.kontakt-b2b .link-geschaeft-inhalt').on('click', function () {
            $('#Kontakt').addClass('show-b2c').removeClass('show-b2b').removeClass('show-beratung');
        });

        $('.kontakt-b2c .link-privat-inhalt').on('click', function () {
            $('#Kontakt').addClass('show-b2b').removeClass('show-b2c').removeClass('show-beratung');
        });

        $('#Kontakt .close').on('click', function() {
            $('#Kontakt').removeClass('show-b2b show-beratung').addClass('show-b2c');
        });
        

        /**
         * Service-Navi Kontakt Link um Prefill ergänzen
         */

        switch($("#headerLine1 li.active").text().trim()) {
            case "Geschäftskunden":
                $('#Kontakt').addClass("show-b2b");
                break;
            case "Kommunen":
                $(".servicenavi .kontakt").attr("href", "/hilfe-service/kontakt/?kunde=Kommune");
                break;
            case "Wohnungswirtschaft":
                $(".servicenavi .kontakt").attr("href", "/hilfe-service/kontakt/?kunde=Wohnungswirtschaft");
                break;
            default:
        }
    });
})(jQuery);
